import React, { useEffect, useState, useLayoutEffect, useRef, useCallback, startTransition } from 'react';
import cn from 'classnames';
import Pay from '@containers/Pay';
import { Form, Formik } from 'formik';
import CancelIcon from '@assets/images/CancelIcon.png';
import style from '../PaymentScreens/paymentScreens.module.scss';
import SimpleKeyBoard from '@components/common/formElements/SimpleKeyboard';
import Survey from '@containers/Survey';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import GiftCard from '../PaymentScreens/giftCardNewUI';
import QrPayFromPhone from '../PaymentScreens/QrPayFromPhone';
import check from '@assets/images/Check.gif';
import handOff from '@assets/images/HAND_OFFnew.gif';
import CashReturn from '@components/CashReturn/indexReVamp';
import Button from '@components/common/LongPressButton';
import Modal from '@components/common/Modal';
import { getObjectValue, urlSearchParams } from '@utility/utills';
import credit_card from '../../assets/images/CreditCardCO.svg';
import cashPaymentLogo from '@assets/images/CashLogo.svg';
import redeem from '../../assets/images/GiftCard.svg';
import ExternalCreditCardLogo from '@assets/images/ExternalCreditCard.svg';
import cross from '@assets/images/receipt_cross.svg';
import { ReactComponent as CrossPopup } from '@assets/images/cross.svg';
import sendText from '@assets/images/sendText.svg';
import { ReactComponent as SearchIcon } from '@assets/images/searchReceiptIcon.svg';
import SUCCESS from '@assets/images/GIFs/SUCCESS.gif';
import StartScreen from './StartScreen/index';
import PaymentScreenOffer from './Paymentscreen/index';
import PaymentScreenlandscape from './Paymentscreen/paymentScreenlandscape';
import CheckPresenter from './CheckPresenter/index';
import { APP_CONFIG } from '@constants';
import CouponScreen from './CouponScreen/index.jsx';
import PaymentConfirmation from './PaymentConfirmation/index';
import EmployeeInitiatedPaymentScreen from './EmployeeInitiatedPaymentScreen/index.jsx';
import EmployeeInitiatedPaymentLandscapeScreen from './EmployeeInitiatedPaymentScreen/employeeInitiatedPaymentLandscapeScreen.jsx';
import TipScreen from './Tips/index';
import SplitBySelectedSeats from './SplitBySelectedSeats/index.jsx';
import SplitEvenly from './SplitEvenly/index.jsx';
import SplitBySeat from './SplitBySeat';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import CallCenter from '../../assets/JSON_Files/call_Center.json';
import TipsLandScape from './Tips/otherAmountlandscape';
import GiftCardReceiptLandscape from './GiftCardReceipt/GiftCardReceiptLandscape';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import { safeJsonParse } from '@utility/helperFunction';
import StartScreenPortrait from './StartScreen/startScreenPortrait';
import { connect } from 'react-redux';

const PaymentScreenReVamp = ({
  receiptTypes,
  isCounter,
  history,
  isWalkUp,
  handleCreditCard,
  onChangeTipAmount,
  onChangeTipPersent,
  handleButtonClickOtherAmount,
  showPoints,
  tipsMessage,
  paymentType,
  sourceType,
  setTextToPayModelOpen,
  stopPopUpOtherAmount,
  setIsTipWarning,
  currenySymbol,
  paymentAmount,
  preAuthFunctionCall,
  setPaymentType,
  unpaidAmount,
  totalAmount,
  tipAmount,
  handleRouteCheck,
  handleCheck,
  logo,
  makeGiftCardBalanceZero,
  handleButtonClick,
  tipsList,
  active,
  paymentCallBack,
  handleReceiptPopUpOpen,
  handleRetry,
  PaymentPageBtn,
  handleSplitEvenly,
  handlePayAnAmount,
  isCash,
  handleKeyboardValue,
  validatePayAnAmount,
  subTotalAmount,
  handleSurveySubmit,
  isGiftCard,
  isSecurityCode,
  handleGiftCard,
  giftCardPayment,
  giftBalance,
  setGiftBalance,
  paidAmount,
  giftCardSupportsSwipe,
  openCardPopUp,
  giftCardNumber,
  handleFailureRoute,
  isCreditCard,
  errorMessage,
  handleProcessCreditError,
  isDone,
  totalAmountForTip,
  charity,
  charityList,
  handleTipsRouteTo,
  applyDonation,
  handleGiftCancel,
  isQrScan,
  isKiosk,
  isTableTop,
  isServerApp,
  pointEarnings,
  successMessage,
  authResponse,
  tableData,
  deviceInfo,
  handleHideCancelIcon,
  handleChangePaymentType,
  userInfo,
  handleDirectToCashConfirmation,
  isPaymentTerminal,
  isExternalCreditCard,
  isTextToPay,
  giftCardImages,
  setNotification,
  seat,
  setIsOpen,
  isOpen,
  handleBackButton,
  giftCardMethods,
  setTipAmount,
  checkboxactive,
  setCheckboxactive,
  setCheckboxactives,
  authInfo,
  isLandScape,
  ShowLandscapeMode,
  countryCode,
  headerImg,
  smsEmailPrintObject,
  setsmsEmailPrintObject,
  handleNoReceipt,
  handleRouteRetry,
  enableOtherAmount,
  enableOtherPercent,
  selectedPayment,
  disableOtherTip,
  serverAppTheme,
  viewDetailsOpen,
  allMenuItems,
  validateTipsForCredit,
  setViewDetailsOpen,
  continueGiftCardPayment,
  swipeGiftCards,
  isCallCenter,
  unPaidAmountForTip,
  setOtherAmountOrPersent,
  checkPresenterPay,
  setPaymentFlowType,
  setIsCreditCardPayment,
  setCheckAndSeats,
  offerCouponGiftCard,
  giftCardData,
  applyAnOfferScreen,
  handleDeleteOffer,
  groupedLoyaltyOffers,
  giftCardScreen,
  handleGiftCardDeleteBalance,
  handleApplyOffer,
  onOtherPaymentOptionClick,
  employeeCheckInRef,
  toggleOtherPaymentOption,
  giftCardDeleteBalance,
  setPayModeType,
  payModeType,
  setInfoDeletion,
  infoDeletion,
  creditCardAmount,
  setCreditCardAmount,
  isAmountEdit,
  setIsAmountEdit,
  handleCreditCardPayment,
  handleGiftCardPayment,
  paymentConfirmation,
  paymentProcess,
  PayByCardBtn,
  handleCreditCardDeleteBalance,
  setShowTicketDetails,
  creditRetryBtn,
  setActive,
  cashMode,
  totalPaymentAmount,
  handleRouteCross,
  handleCashClearBalance,
  handleCashCompletePayment,
  handlePayAtCounterPayment,
  handleOpenEditModal,
  seatItemHashTable,
  splitTableData,
  setSplitTableData,
  selectedStage,
  selectedItem,
  selectedSeats,
  onClearSplit,
  handleStageSelection,
  handleItemSelection,
  handleCheckItems,
  handleStageMove,
  handleCardSelection,
  handleBackButtonClick,
  handleStagePaymentSubmit,
  handleSplitPayment,
  setErrorPopUp,
  setSelectedStage,
  handleOpenDeleteModal,
  handleCheckAllItems,
  totalVisible,
  setTotalVisible,
  btnPrimary,
  setBtnPrimary,
  setPaymentConfirmation,
  handleLoyaltyInfo,
  applyTipForPayment,
  navigate,
  location,
  hasAutoGratuity,
  isAutoGratuityPresent,
  disablePayment,
  isDriveThru,
  isSwipe,
  getLoyaltyOfferState,
  speedOrderMode,
  isTogo,
  setSendOrderConfirmation,
  onSubmitTips,
  isOrderingPortrait,
  isTipOnlyEnabled,
  validateTipForTipOnly,
  paymentLandscapeOrientation,
  isBackNavTipClear,
  getRoundingPayment,
  ...props
}) => {
  const otherAmountName = 'otheramountname';
  const [inputName, setInputName] = useState(`${otherAmountName}`);
  const [inputs, setInputs] = useState({});
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;
  const inputNameRef = useRef(inputName);
  inputNameRef.current = inputName;
  const checkboxactiveRef = useRef(checkboxactive);
  checkboxactiveRef.current = checkboxactive;
  const onChangeTipPersentRef = useRef(onChangeTipPersent);
  onChangeTipPersentRef.current = onChangeTipPersent;
  const onChangeTipAmountRef = useRef(onChangeTipAmount);
  onChangeTipAmountRef.current = onChangeTipAmount;
  const currenySymbolRef = useRef(currenySymbol);
  currenySymbolRef.current = currenySymbol;
  const themeProperties =
    JSON.parse(window.sessionStorage.getItem('themeProperties')) || {};
  const [tipList, setTipList] = useState([]);
  const [tipvalue, setTipvalue] = useState('0%');
  const [value, setValue] = useState('');
  const [showNoTipModal, setShowNoTipModal] = useState(false);
  const [isDoneClick, setIsDoneClick] = useState(false);
  const [previousScreen, setPreviousScreen] = useState(1);
  const [otherAmount, setotherAmount] = useState(false);
  const paymentCheckData =
    JSON.parse(window.sessionStorage.getItem('paymentCheck')) || {};

  const callCenterModeUserInfo = JSON.parse(
    window.sessionStorage.getItem('callCenterUserInfo')
  );
  const seatTipType = seat?.paymentCheck?.tipType;
  const seatTipAmount = seat?.paymentCheck?.tipAmount;
  const authData = safeJsonParse(window.sessionStorage.getItem('auth'), {});
  const creditCardReadyScreen = () => {
    handleCreditCardPayment(
      Number(seat?.paymentCheck?.paymentAmount)?.toFixed(2),
      'payByCard'
    );
  };

  const handleBackForTipOnly = () => {
    setPaymentType(4);
    navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${seat?.paymentCheck?.id
      }?ticketSplitTypeId=1&splitValue=1&screenType=4&type=payType`,
      { replace: true }
    );
  };

  const getTipOnlyOtherAmount = safeJsonParse(window.sessionStorage.getItem("otherTipAmount"));
  const getConfirmationLogo = () => {
    let image = logo;
    const nullCheck = imageUrl => imageUrl === null;
    if (isKiosk) {
      image = themeProperties.kioskConfirmationPageImageUrl;
    } else if (isTableTop) {
      image = themeProperties.tableTopConfirmationPageImageUrl;
    } else if (isServerApp) {
      let serverAppImage = themeProperties.serverAppConfirmationPageImageUrl;
      if (nullCheck(serverAppImage)) {
        if (isCallCenter) {
          return CallCenter;
        } else return image;
      } else {
        return serverAppImage;
      }
    } else if (isPaymentTerminal) {
      image = themeProperties.serverAppConfirmationPageImageUrl;
    }
    return image;
  };

  const handleOtherPaymentOptions = value => {
    if (value === 1) {
      getPaymentCheck();
    }
    setPreviousScreen(value);
    setPaymentType(32);

    const type =
      urlSearchParams('type') !== null ? urlSearchParams('type') : 'payType';

    navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${paymentCheckData.id
      }?ticketSplitTypeId=${urlSearchParams(
        'ticketSplitTypeId'
      )}&splitValue=${urlSearchParams(
        'splitValue'
      )}&screenType=32&type=${type}`,
      { replace: true }
    );
  };

  const buttonAllignment = () => {
    const btn_value = Object.values(receiptTypes).filter(val => val === true)
      .length;
    if (btn_value === 1) {
      return 'col-12 h-100';
    } else if (btn_value === 2) {
      return 'col-6 h-100';
    } else if (btn_value === 3) {
      return 'col-4 h-90 px-0';
    }
  };

  const handleReceiptType = () => {
    smsEmailPrintObject.smsReceiptStatus &&
      setsmsEmailPrintObject(!smsEmailPrintObject.smsReceiptStatus);
    smsEmailPrintObject.emailReceiptStatus &&
      setsmsEmailPrintObject(!smsEmailPrintObject.emailReceiptStatus);
    smsEmailPrintObject.printReceiptStatus &&
      setsmsEmailPrintObject(!smsEmailPrintObject.printReceiptStatus);
  };

  const couponScreenRouting = () => {
    setPaymentType(36);
    navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${paymentCheckData.id
      }?ticketSplitTypeId=${urlSearchParams(
        'ticketSplitTypeId'
      )}&splitValue=${urlSearchParams(
        'splitValue'
      )}&screenType=36&type=${urlSearchParams(`type`)}`,
      { replace: true }
    );
  };

  const OtherAmountTipValue = () => {
    if ([24].includes(paymentType)) {
      setTipAmount(seatTipAmount);
      if (seatTipType === 3 && totalVisible) {
        setTipvalue(
          `${checkDecimal(
            ((100 * seatTipAmount) / getTipAmount(totalAmountForTip))?.toFixed(
              1
            )
          )}%`
        );
      } else if (seatTipType === 4 && !totalVisible) {
        setValue(currenySymbol + seatTipAmount);
      } else {
        setTipAmount(0);
      }
    }
  };

  const handleCouponCancel = () => {
    setPaymentType(31);
    navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${paymentCheckData.id
      }?ticketSplitTypeId=${urlSearchParams(
        'ticketSplitTypeId'
      )}&splitValue=${urlSearchParams(
        'splitValue'
      )}&screenType=31&type=${urlSearchParams(`type`)}`,
      { replace: true }
    );
  };
  useLayoutEffect(() => {
    if (seat?.paymentCheck?.tip == null) {
      setotherAmount(false);
    }
  }, [urlSearchParams('screenType')]);

  useEffect(() => {
    setTipList([]);
    if (tipsList.length > 0) {
      tipsList.forEach((element, index) => {
        if (index !== tipsList.length - 1) {
          setTipList(tipList => [...tipList, element]);
        }
      });
    }
  }, [seat.paymentCheck]);

  const getTipAmount = tipAmount => {
    let calculatedTipAmount = tableData.subTotalAmount;
    if (authInfo?.tipInfo?.suggestedTipExcludesDiscount === false) {
      calculatedTipAmount += tableData?.discountAmount;
      if (calculatedTipAmount < 0) {
        calculatedTipAmount = 0;
      }
    }
    if (authInfo?.tipInfo?.suggestedTipIncludesTax === true) {
      calculatedTipAmount += tableData?.taxAmount;
      if (calculatedTipAmount < 0) {
        calculatedTipAmount = 0;
      }
    }

    if (unPaidAmountForTip > 0 && unPaidAmountForTip != totalAmount) {
      calculatedTipAmount =
        (Number(unPaidAmountForTip) / Number(totalAmount)) * Number(tipAmount);
    }
    return Number(calculatedTipAmount);
  };

  useEffect(() => {
    setTipvalue('');
    setValue('');
    setInputs({
      ...inputs,
      [inputName]: '',
    });
    if ([4].includes(paymentType)) {
      if (seatTipType == 3) {
        setTipvalue(
          `${checkDecimal(
            ((100 * seatTipAmount) / getTipAmount(totalAmountForTip))?.toFixed(
              1
            )
          )}%`
        );
        setBtnPrimary({
          isAmount: {
            background: 'transparent',
            color: serverAppTheme?.primary_text,
          },
          isPercent: {
            background: serverAppTheme?.selected,
            color: '#000',
          },
        });
        setOtherAmountOrPersent(false);
        setTotalVisible(false);
        setInputs({
          ...inputs,
          [inputName]:
            `${checkDecimal(
              ((100 * seatTipAmount) / totalAmountForTip)?.toFixed(1)
            )}`?.toString() || '',
        });
      } else if (seatTipType == 4) {
        setTotalVisible(true);
        setOtherAmountOrPersent(true);
        setValue(currenySymbol + seatTipAmount);
        setBtnPrimary({
          isAmount: {
            background: serverAppTheme?.selected,
            color: '#000',
          },
          isPercent: {
            background: 'transparent',
            color: serverAppTheme?.primary_text,
          },
        });
        setInputs({
          ...inputs,
          [inputName]: seatTipAmount?.toString() || '',
        });
      } else if (seatTipType === 1) {
        setotherAmount(false);
      }
    }
  }, [paymentType]);

  useEffect(() => {
    if (isBackNavTipClear?.current) {
      isBackNavTipClear.current = false;
      return;
    }
    setBtnPrimary({
      isAmount: {
        background: serverAppTheme?.selected,
        color: '#000',
      },
      isPercent: {
        background: 'transparent',
        color: serverAppTheme?.primary_text,
      },
    });
    setTotalVisible({
      amount: true,
      percent: false,
    });
  }, [seat?.paymentChecks]);

  useEffect(() => {
    if (isDoneClick === true && isAlpha === true) {
      setKeyboardType('numericAlpha');
      setIsDoneClick(false);
    }
  }, [isDoneClick === true && isAlpha === true]);

  const Fullcheck = () => {
    return (
      <>
        <div className="col-12 px-0 pl-20 pr-20">
          {isCreditCard && (
            <button
              type="button"
              className={cn(
                'btn80 btn my-1 w-100 p-1 btn-ripple ',
                subTotalAmount === 0 ? style.opacity6 : ''
              )}
              style={{
                background: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
              }}
              onClick={() => handleCheck('creditCard')}
              disabled={subTotalAmount === 0 || Number(unpaidAmount) === 0}
            >
              <div
                className={cn('fs-18 h-100', style.divForPayment)}
                style={{
                  fontSize: isPaymentTerminal
                    ? '1.8rem'
                    : ShowLandscapeMode
                      ? '24px'
                      : '16px',
                }}
              >
                <div className="text-center h-100 d-flex flex-column justify-content-center align-items-center">
                  <img src={credit_card} alt="credit card" />
                  <div
                    className={'fs_28'}
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: '600',
                      letterSpacing: 0,
                    }}
                  >
                    {LABEL().CREDIT_CARD}
                  </div>
                </div>
              </div>
            </button>
          )}
        </div>
        <div className="col-12 px-0 h-50 flex-row row mx-0 align-items-center justify-content-end">
          {isQrScan && (
            <button
              type="button"
              className={cn(
                'col btn80 btn mr-2 mt-1 p-1  btn-ripple',
                sourceType === 7 ? style.opacity6 : '',
                isServerApp ? 'fs-28' : ''
              )}
              style={{
                background: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
              }}
              onClick={() => handleCheck('qrPay')}
              disabled={isTableTop}
            >
              <div
                className={cn('fs-18', style.divForPayment)}
                style={{
                  fontSize: isPaymentTerminal
                    ? '1.8rem'
                    : ShowLandscapeMode
                      ? '24px'
                      : '26px',
                }}
              >
                {LABEL().QR_PAY_FROM_PHONE}
              </div>
            </button>
          )}
          {sourceType !== 0 && !isTableTop && isTextToPay && (
            <button
              type="button"
              disabled={sourceType === 7}
              className={cn(
                'col btn80 btn mr-2 mt-1 btn-ripple d-flex align-items-center justify-content-center',
                sourceType === 7 ? style.opacity6 : '',
                isServerApp ? 'fs-28' : ''
              )}
              style={{
                padding: '0.75rem',
                background: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
              }}
              onClick={() => setTextToPayModelOpen(true)}
            >
              <div className="text-center h-100 ">
                <img
                  src={sendText}
                  style={{
                    width: isLandScape ? '10%' : '40px',
                    height: '',
                  }}
                  className="mb-1"
                  alt="local_atm"
                />
                <div
                  className={cn('fs-24')}
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: '600',
                    fontSize: 'Max',
                    letterSpacing: 0,
                    lineHeight: '21.6px',
                  }}
                >
                  Text <br /> to pay
                </div>
              </div>
            </button>
          )}
          {isCash && (
            <Button
              type="button"
              className={cn(
                'col btn80 btn mr-1 mt-1 p-1  d-flex justify-content-center align-items-center btn-ripple text-underline',
                isTableTop ? style.opacity6 : ''
              )}
              style={{
                background: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
              }}
              onClick={() => handleCheck('cash')}
              onLongPress={() => {
                handleDirectToCashConfirmation(true);
                handleCheck('cash');
              }}
              disabled={isTableTop}
            >
              <div className={cn('h-100 col-12 px-0')}>
                <div className="text-center h-100 w-100 d-flex flex-column justify-content-center align-items-center">
                  <img src={cashPaymentLogo} alt="local_atm" />
                  <div
                    className={cn('fs_28')}
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: '600',
                      letterSpacing: 0,
                    }}
                  >
                    {LABEL().CASH_PAYMENT}
                  </div>
                </div>
              </div>
            </Button>
          )}
          {isGiftCard && (
            <button
              type="button"
              className={cn(
                'col btn80 btn mt-1 ml-1 p-1  btn-ripple',
                subTotalAmount === 0 ? style.opacity6 : '',
                isServerApp ? 'fs-28' : ''
              )}
              style={{
                background: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
              }}
              onClick={() => handleCheck('giftCard')}
              disabled={subTotalAmount === 0}
            >
              <div className={cn('h-100 col-12 px-0')}>
                <div className="text-center h-100 w-100 d-flex flex-column justify-content-center align-items-center">
                  <img src={redeem} alt="redeem" />
                  <div
                    className="fs_28"
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: '600',
                      letterSpacing: 0,
                    }}
                  >
                    {LABEL().GIFT_CARD}
                  </div>
                </div>
              </div>
            </button>
          )}
          {isExternalCreditCard && (
            <button
              type="button"
              className={cn(
                'col btn80 btn ml-1 mt-1  btn-ripple',
                style.p_12,
                subTotalAmount === 0 ? style.opacity6 : '',
                isServerApp ? 'fs-28' : ''
              )}
              style={{
                background: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
              }}
              onClick={() => handleCheck('externalCreditCard')}
              disabled={subTotalAmount === 0 || unpaidAmount === 0}
            >
              <div className="text-center">
                <img
                  src={ExternalCreditCardLogo}
                  alt="redeem"
                  className="mb-2"
                />
                <div
                  className={cn('fs-24')}
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: '600',
                    letterSpacing: 0,
                    lineHeight: '21.6px',
                  }}
                >
                  {LABEL().EXTERNALCREDIT_CARD}
                </div>
              </div>
            </button>
          )}
          {urlSearchParams('externalCreditCard') && !isExternalCreditCard && (
            <button
              type="button"
              className={cn(
                'col btn80 btn mx-1 my-1 od-btn-primary btn-primary btn-ripple ',
                subTotalAmount === 0 ? style.opacity6 : '',
                isServerApp ? 'fs-28' : ''
              )}
              onClick={() => handleCheck('externalCreditCard')}
              disabled={subTotalAmount === 0 || unpaidAmount === 0}
            >
              <div
                className="fs-18"
                style={{
                  fontSize: isPaymentTerminal ? '16px' : '26px',
                  textTransform: 'uppercase',
                }}
              >
                {LABEL().EXTERNALCREDIT_CARD}
              </div>
            </button>
          )}
        </div>
        <Modal isOpen={isOpen} isModalCenter>
          <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
            <div className="px-0 text-right">
              <i
                role="presentation"
                onClick={() => setIsOpen(false)}
                className="fa fa-times fs-30"
                aria-hidden="true"
              />
            </div>
            <div className="col-12 fs-18 mt-10 fw-700 text-center">
              <div className="fs-20">
                {CUSTOM_MESSAGES().PREAUTH_POST_ONE}
                {totalAmount} {CUSTOM_MESSAGES().PREAUTH_POST_TWO}
              </div>
            </div>
            <div className="col-12 d-flex justify-content-center">
              <button
                type="submit"
                className="col-4 m-2 btn btn-ripple btn-secondary btn-lg od-btn-secondary"
                onClick={() => setIsOpen(false)}
              >
                <div className="fs-18">{LABEL().NO}</div>
              </button>
              <button
                type="submit"
                className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary"
                onClick={() => {
                  handleCheck('preAuth');
                  setIsOpen(false);
                }}
              >
                <div className="fs-18">{LABEL().YES}</div>
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  };

  const mewVal = val => {
    const newValdata = val.toString().split('.');
    if (newValdata[1]) {
      const newstr = newValdata[1].substring(0, 2);
      if (Number(newstr) > 0) {
        return val.toFixed(2);
      } else {
        return newValdata[0];
      }
    }
    return val;
  };

  const renderModifier = (modifiersObj, nest) =>
    !isCallCenter
      ? (modifiersObj || []).map(modifier => (
        <div
          key={modifier.modifierId}
          className={modifier.price ? 'col-12 text-left p-0 fs-16' : 'd-none'}
        >
          {`${modifier.quantity > 1 ? `- ${modifier.quantity} x ` : '- '} ${modifier.modifierName
            } ${modifier.price
              ? `(${currenySymbol}${modifier.price.toFixed(2)})`
              : ''
            }`}
          {(modifier.note || modifier.comment) && (
            <div className="pl-2">{modifier.note || modifier.comment}</div>
          )}
          {modifier.modifiers && modifier.modifiers.length > 0 && (
            <div className="pl-2">
              {renderModifier(modifier.modifiers, true)}
            </div>
          )}
        </div>
      ))
      : (modifiersObj || []).map(modifier => (
        <div
          key={modifier.modifierId}
          className={modifier.price && 'col-12 text-left p-0 fs-16 fw-500'}
        >
          <div className="col-12 d-flex p-0">
            <div className={cn('col-2 text-center fs-16 fw-500')}>
              {modifier.quantity >= 1 && modifier.quantity}
            </div>
            <div className={cn('col-7 p-0 text-left pr-5')}>
              {nest ? (
                <div className="d-flex">
                  <span style={{ color: serverAppTheme?.modifier_arrowDown }}>
                    ↳
                  </span>
                  <div className="mt-1 ml-1 fw-500">
                    {modifier.modifierName}
                  </div>
                </div>
              ) : (
                <div className="fs-16 fw-500">{modifier.modifierName}</div>
              )}
            </div>
            {modifier.price ? (
              <div
                className={cn(
                  isCallCenter && nest
                    ? 'mt-1 col-3 p-0 text-right pr-5 fs-16 fw-500'
                    : 'col-3 p-0 text-right pr-5 fs-16 fw-500'
                )}
              >{`${currenySymbol}${modifier.price.toFixed(2)}`}</div>
            ) : (
              <div
                className={cn(
                  isCallCenter && nest
                    ? 'mt-1 col-3 p-0 text-right pr-5 fs-16 fw-500'
                    : 'col-3 p-0 text-right pr-5 fs-16 fw-500'
                )}
              >
                $0.0
              </div>
            )}
          </div>
          {modifier.modifiers && modifier.modifiers.length > 0 && (
            <div className="fs-16 fw-500">
              {renderModifier(modifier.modifiers, true)}
            </div>
          )}
        </div>
      ));

  const excludeItemFromReceiptScreen = item => {
    let excludeProduct = false;
    allMenuItems?.forEach(insideItems => {
      if (
        insideItems.id === item.menuItemId &&
        insideItems?.excludeFromReceipt
      ) {
        excludeProduct = true;
      }
    });
    return excludeProduct;
  };

  const onChangePersentage = useCallback(e => {
    setValue('');
    const currentInputs = inputsRef.current;
    const currentInputName = inputNameRef.current;
    const values =
      e !== '{bksp}'
        ? {
          ...currentInputs,
          [currentInputName]: currentInputs[currentInputName]
            ? currentInputs[currentInputName].concat(e)
            : ''.concat(e),
        }
        : {
          ...currentInputs,
          [currentInputName]: currentInputs[currentInputName]
            ? currentInputs[currentInputName].slice(0, -1)
            : '',
        };

    setInputs({
      ...currentInputs,
      [currentInputName]: values[currentInputName],
    });
    if (values[currentInputName] === '') {
      setTipvalue('0%' + '');
    } else {
      setTipvalue(values[currentInputName] + '%');
    }
    startTransition(() => {
      onChangeTipPersentRef.current(checkboxactiveRef.current, values[currentInputName]);
    });
  }, []);

  const handleOtherAmountContinue = (tips, tipPercentage, ss) => {
    const warningPercent = authData?.tipInfo?.warningPercent;
    const warningAmount = authData?.tipInfo?.warningAmount;
    const tipAmount = +value.slice(1);
    const effectiveTipAmount = tipAmount === 0 ? ss : tipAmount;

    // For Tip Only flow, only warningAmount is checked (warningPercent is ignored)
    const shouldWarn = isTipOnlyEnabled
      ? (warningAmount != null && warningAmount > 0 && effectiveTipAmount >= warningAmount)
      : (warningPercent != null && warningPercent > 0 && tipPercentage >= warningPercent) ||
        (warningAmount != null && warningAmount > 0 && effectiveTipAmount >= warningAmount);

    if (shouldWarn) {
      setIsTipWarning(true);
    } else {
      onSubmitTips();
    }
  };

  const checkDecimal = val => {
    const newValdata = val.toString().split('.');
    if (newValdata[1]) {
      const newstr = newValdata[1].substring(0, 1);
      if (Number(newstr) > 0) {
        return Number(val).toFixed(1);
      } else {
        return newValdata[0];
      }
    }
    return val;
  };

  const onClickBtn = useCallback(e => {
    setTipvalue('0%');
    const currentInputs = inputsRef.current;
    const currentInputName = inputNameRef.current;
    const values =
      e !== '{bksp}'
        ? {
          ...currentInputs,
          [currentInputName]: currentInputs[currentInputName]
            ? currentInputs[currentInputName].concat(e)
            : ''.concat(e),
        }
        : {
          ...currentInputs,
          [currentInputName]: currentInputs[currentInputName]
            ? currentInputs[currentInputName].slice(0, -1)
            : '',
        };

    setInputs({
      ...currentInputs,
      [currentInputName]: values[currentInputName],
    });
    if (values[currentInputName] === '') {
      setValue(currenySymbolRef.current + '0.00');
    } else {
      setValue(currenySymbolRef.current + values[currentInputName]);
    }
    startTransition(() => {
      onChangeTipAmountRef.current(checkboxactiveRef.current, values[currentInputName]);
    });
  }, []);
  const setTotalVisibleVal = val => {
    setTotalVisible(val);
    setOtherAmountOrPersent(val);
    setTipvalue('');
    setValue('');
    setCheckboxactives(false);
    setInputs({
      ...inputs,
      [inputName]: '',
    });
    OtherAmountTipValue();
  };

  const giftCardReceiptTile = (item, index) => {
    return (
      <div
        className="d-flex flex-column mt-1 p-2 fw-600"
        style={{
          backgroundColor: serverAppTheme?.send_tab_unselected,
          borderRadius: '4px',
        }}
      >
        <div className="d-flex justify-content-between fs-20 fw-normal">
          <span className="col-4 px-0 text-left d-flex align-items-center">
            {item?.name}
          </span>
          <span
            style={{ width: '114px' }}
            className="col-6 px-0 text-left overflowY d-flex align-items-center"
          >
            {item?.number}
          </span>
          <span className="col-2 px-0 text-left d-flex align-items-center">
            {LABEL().CURRENCY_SYMBOL + item.amount.toFixed(2)}
          </span>
        </div>
        {/* <div className="fs-16 fw-normal t-50 pt-3">
          <span className="mr-1">Status:</span>
          <span>{getStatus(item?.status)}</span>
        </div>
        <div className="col-8 px-0 fs-16 fw-normal pb-2 pt-1">
          <span className="mr-1">Message:</span>
          <span>{item?.message ? item?.message : 'NA'}</span>
        </div> */}
      </div>
    );
  };

  const giftCardReceipt = () => {

    if (paymentLandscapeOrientation) {
      return (
        <GiftCardReceiptLandscape
          receiptTypes={receiptTypes}
          isServerApp={isServerApp}
          handleReceiptPopUpOpen={handleReceiptPopUpOpen}
          handleCheck={handleCheck}
          serverAppTheme={serverAppTheme}
          continueGiftCardPayment={continueGiftCardPayment}
          props={props}
        />
      );
    }

    return (
      <div className="h-100 position-relative">
        <div
          className="col-12 pt-1 px-5 text-center fs_20 fw-600 h-10"
          style={{ color: serverAppTheme?.primary_text }}
        >
          {LABEL().GIFT_CARD_ACTIVATION_MESSAGE}
        </div>
        <div
          className="col-12 px-0 d-flex justify-content-around h-12 align-items-center"
          style={{ padding: '1.05rem  0' }}
        >
          {isServerApp && receiptTypes?.sms && (
            <div className="h-100 col-4 px-0">
              <TouchableButton
                type="button"
                className={cn(
                  'od-primary-btn-bg-color od-primary-btn-font-color col-12 h-100 border-0 rounded'
                )}
                onClick={e => {
                  e.preventDefault();
                  handleReceiptPopUpOpen('phone');
                }}
                style={{
                  backgroundColor: serverAppTheme?.secondaryBtn,
                  color: serverAppTheme?.btn_font_color,
                }}
              >
                <div className={cn(style.divForPayment, 'fs_24 fw-600')}>
                  {LABEL().TEXT}
                </div>
              </TouchableButton>
            </div>
          )}
          {isServerApp && receiptTypes?.email && (
            <div className="h-100 col-4 px-1">
              <TouchableButton
                type="button"
                className={cn(
                  'od-primary-btn-bg-color od-primary-btn-font-color col-12 h-100 border-0 rounded'
                )}
                onClick={e => {
                  e.preventDefault();
                  handleReceiptPopUpOpen('email');
                }}
                style={{
                  backgroundColor: serverAppTheme?.secondaryBtn,
                  color: serverAppTheme?.btn_font_color,
                }}
              >
                <div className={cn(style.divForPayment, 'fs_24 fw-600')}>
                  {LABEL().GIFTCARD_EMAIL_RECEIPT}
                </div>
              </TouchableButton>
            </div>
          )}

          {isServerApp && receiptTypes?.print && (
            <div className="h-100 col-4 px-0">
              <TouchableButton
                type="button"
                className={cn(
                  'od-primary-btn-bg-color od-primary-btn-font-color col-12 h-100 border-0 rounded'
                )}
                onClick={e => {
                  e.preventDefault();
                  handleCheck('print');
                }}
                style={{
                  backgroundColor: serverAppTheme?.secondaryBtn,
                  color: serverAppTheme?.btn_font_color,
                }}
              >
                <div className={cn(style.divForPayment, 'fs_24 fw-600')}>
                  {LABEL().PRINT}
                </div>
              </TouchableButton>
            </div>
          )}
        </div>
        <div
          style={{ height: '4%', color: serverAppTheme?.secondary_text }}
          className="col-12 px-2 d-flex justify-content-between fs-16 fw-500"
        >
          <span className="col-4 px-0 text-left d-flex align-items-center justify-content-start">
            {LABEL().CARDNAME}
          </span>
          <span className="col-6 px-0 text-left d-flex align-items-center justify-content-start">
            {LABEL().CARDNUMBER}
          </span>
          <span className="col-2 px-0 text-left d-flex align-items-center justify-content-start">
            {LABEL().AMOUNT}
          </span>
          {/* <span className="col-2 px-0 text-center d-flex align-items-center justify-content-center">
            {LABEL().GC_SWIPE_RECEIPT}
          </span> */}
        </div>
        <div className="h-65 col-12 px-0 justify-content-center overflowY">
          {JSON.parse(window.sessionStorage.getItem('seat'))
            ?.paymentCheck?.cards?.filter(el => el.type === 2  && !el.void)
            ?.map((item, index) => giftCardReceiptTile(item, index))}
        </div>
        <div
          className="h-8 col-12 px-0 d-flex justify-content-center align-items-end position-absolute"
          style={{ bottom: props.showCheckSeat() ? '78px' : '35px' }}
        >
          <button
            type="button"
            className={cn(
              'col-12 px-0 border-0 rounded od-primary-btn-bg-color od-primary-btn-font-color'
            )}
            onClick={() => {
              if (
                !receiptTypes?.sms &&
                !receiptTypes?.email &&
                !receiptTypes?.print
              ) {
                continueGiftCardPayment(true);
              } else {
                continueGiftCardPayment();
              }
            }}
            style={{
              height: '7.5vh',
              backgroundColor: serverAppTheme?.secondaryBtn,
              color: serverAppTheme.btn_font_color,
            }}
          >
            <div
              className={cn(
                'fs_28 fw-600 d-flex justify-content-center align-items-center'
              )}
            >
              {LABEL().CONTINUE}
            </div>
          </button>
        </div>
      </div>
    );
  };

  const Charity = () => {
    return (
      <div className="col-12 h-100 row mx-0">
        <div className="col-12 h-80 mb-1">
          <div className="fs-26 h-15 od-text-primary mb-1 text-center">
            {charity.name}
          </div>
          <div className="col-12 h-50 mb-1 text-center">
            <img src={charity.imageUrl} alt="" className="h-100" />
          </div>
          <div className="h-30 mb-2 col-12 p-0 overflowY">
            {charity.description}
          </div>
        </div>
        <div className="col-12 h-25 p-0">
          {charityList && charityList.length > 0 ? (
            <div className="col-12 od-text-primary fs-20 text-center p-0">
              <div className={style.charityWrapper}>
                {charityList.map(item => {
                  return (
                    <div
                      key={item.key}
                      role="presentation"
                      onClick={() => {
                        handleKeyboardValue('');
                        handleButtonClick(item.displayKey);
                      }}
                      className={cn(
                        'border rounded border-color-secondary flex-grow d-flex flex-column align-items-center justify-content-center',
                        item.displayKey === active
                          ? 'bg-grey color-white od-btn-secondary'
                          : ''
                      )}
                    >
                      <div>{item.displayKey}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
        <div className="col-12 h-30 flex-column p-0 d-flex justify-content-end py-2">
          <button
            type="button"
            className="btn rounded od-btn-primary btn-primary btn-ripple w-100 my-1"
            onClick={() => applyDonation()}
          >
            <div className="fs-18">{LABEL().APPLY_DONATION}</div>
          </button>
          <button
            type="button"
            className="btn rounded od-btn-primary btn-primary btn-ripple w-100 my-1"
            onClick={() => handleTipsRouteTo()}
          >
            <div className="fs-18">{LABEL().SKIP_DONATION}</div>
          </button>
        </div>
      </div>
    );
  };

  const getSplitsComplete = () => {
    let val = true;
    seat?.paymentChecks?.forEach(v => {
      if (v.paymentAmount > 0) {
        val = false;
      }
    });
    return val;
  };
  const checkForUnpaidAmt = () => {
    return seat?.paymentChecks?.filter(val => val.unpaidAmount > 0)?.length > 0;
  };

  const PaymentRecipt = () => {
    return (
      <div
        className="col-12 h-95 row mx-0 justify-content-center align-items-end pt-2 od-text-primary text-primary"
        style={{ position: 'fixed', width: '90%' }}
      >
        {themeProperties?.serverAppLogoImageUrl && (
          <div
            className="col-12 py-2 row mx-0 align-items-center"
            style={(!isCounter || !isDriveThru) ? { top: '3px', position: 'absolute' } : {}}
          >
            <img
              src={themeProperties.serverAppLogoImageUrl}
              alt=""
              className="img-fluid mx-auto d-block h-100"
              style={{
                maxHeight: '250px',
              }}
            />
          </div>
        )}
        <div
          className={cn(
            'col-12 row justify-content-center align-items-center p-0 text-center fs-22 fw-600',
            style.divForPayment
          )}
          style={(!isCounter || !isDriveThru) ? { top: '77px' } : {}}
        >
          {LABEL().PAYMENT_RECEIPT}
        </div>
        <div className="col-12 p-0 ">
          {(((isServerApp || isPaymentTerminal) && receiptTypes?.sms) ||
            isTableTop) && (
              <button
                type="button"
                className={cn(
                  'btn od-btn-primary btn-primary btn-ripple my-2 w-100 text-uppercase '
                )}
                onClick={() => handleReceiptPopUpOpen('phone')}
              >
                <div className={cn('fs-18', style.divForPayment)}>
                  {LABEL().TEXT}
                </div>
              </button>
            )}
          {(((isServerApp || isPaymentTerminal) && receiptTypes?.email) ||
            isTableTop) && (
              <button
                type="button"
                className={cn(
                  'btn od-btn-primary btn-primary btn-ripple my-2 w-100 text-uppercase '
                )}
                onClick={() => handleReceiptPopUpOpen('email')}
              >
                <div className={cn('fs-18', style.divForPayment)}>
                  {LABEL().EMAIL}
                </div>
              </button>
            )}
          {(((isServerApp || isPaymentTerminal) && receiptTypes?.print) ||
            isTableTop) && (
              <button
                type="button"
                className="btn od-btn-primary btn-primary btn-ripple my-2 w-100 "
                onClick={() => handleCheck('print')}
              >
                <div
                  className={cn('fs-18', style.divForPayment)}
                  style={{ textTransform: 'uppercase' }}
                >
                  {LABEL().PRINT}
                </div>
              </button>
            )}
          <button
            type="button"
            className={cn(
              'btn od-btn-primary btn-primary btn-ripple mt-2 w-100 '
            )}
            onClick={() => handleCheck('receipt')}
          >
            <div className={cn('fs-18', style.divForPayment)}>
              {LABEL().NO_RECEIPT_OPTION}
            </div>
          </button>
        </div>
      </div>
    );
  };

  const confirmationAndReceiptScreen = () => {
    return (
      <div
        className="col-12 px-0 mx-0 justify-content-center h-100 position-relative"
        style={{ color: serverAppTheme?.primary_text }}
      >
        {/* 1. text*/}
        <div className={cn('col-12')}>
          <div
            className={cn("col-12 text-center fw-600", isLandScape ? 'fs_24' : 'fs_32')}
            style={{ paddingTop: '0.25rem' }}
          >
            {CUSTOM_MESSAGES().RS_PAYMENT_COMPLETE}
          </div>
          <div
            className="col-12 text-center fs_20 fw-500"
            style={{ paddingTop: isLandScape ? '0.5rem' : '1.5rem' }}
          >
            {CUSTOM_MESSAGES().RS_IT_WAS_GREAT_SERVING_YOU}
          </div>
          <div className={cn("col-12 text-center fs_20 fw-500", isLandScape ? 'pb-10' : 'pb-50')}>
            {CUSTOM_MESSAGES().RS_PLEASE_COME_BACK_SOON}
          </div>
        </div>
        {/* 2. button, receipt, details*/}
        <div className={cn('col-12 p-0 flex-row justify-content-between pt-1')}>
          {!smsEmailPrintObject?.NoReceipt &&
            !smsEmailPrintObject?.smsReceiptStatus &&
            !smsEmailPrintObject?.emailReceiptStatus &&
            !smsEmailPrintObject?.printReceiptStatus ? (
            <>
              {/* 2.1 buttons */}
              <div className={cn("px-0 d-flex fs_24 fw-600", isLandScape ? 'col-8 m-auto pb-2' : 'col-12 pb-3')}>
                {(((isServerApp || isPaymentTerminal) && receiptTypes?.sms) ||
                  isTableTop) && (
                    <div
                      className={cn(
                        'col-4 pr-1 d-flex h-100 justify-content-center align-items-end fw-600',
                        buttonAllignment()
                      )}
                    >
                      <TouchableButton
                        type="button"
                        className={cn(
                          'px-4 mx-0 my-1 btn-ripple justify-content-center align-items-center border-0 fw-600  od-primary-btn-bg-color od-primary-btn-font-color',
                          style.receiptReceiveModeButtons,
                        )}
                        onClick={e => {
                          e.preventDefault();
                          handleReceiptPopUpOpen('phone');
                        }}
                        style={{
                          background: serverAppTheme?.secondaryBtn,
                          lineHeight: '1.7025rem',
                          height: isLandScape && '56px',
                          fontSize: isLandScape && '1.5rem',
                        }}
                        rippleEffect={true}
                      >
                        {LABEL().PAY_TEXT_RECEIPT}
                      </TouchableButton>
                    </div>
                  )}
                {(((isServerApp || isPaymentTerminal) && receiptTypes?.email) ||
                  isTableTop) && (
                    <div
                      className={cn(
                        'col-4 px-1 d-flex justify-content-center h-100 align-items-end fs_24 fw-600',
                        buttonAllignment()
                      )}
                    >
                      <TouchableButton
                        type="button"
                        className={cn(
                          'mx-0 my-1 btn-ripple justify-content-center align-items-center border-0 px-3 fw-600  od-primary-btn-bg-color od-primary-btn-font-color',
                          style.receiptReceiveModeButtons,
                        )}
                        onClick={e => {
                          e.preventDefault();
                          handleReceiptPopUpOpen('email');
                        }}
                        style={{
                          background: serverAppTheme?.secondaryBtn,
                          lineHeight: '1.7025rem',
                          height: isLandScape && '56px',
                          fontSize: isLandScape && '1.5rem',
                        }}
                        rippleEffect={true}
                      >
                        {LABEL().PAY_EMAIL_RECEIPT}
                      </TouchableButton>
                    </div>
                  )}

                {(((isServerApp || isPaymentTerminal) && receiptTypes?.print) ||
                  isTableTop) && (
                    <div
                      className={cn(
                        'col-4 pl-1 d-flex h-100 justify-content-center align-items-end fw-600',
                        buttonAllignment()
                      )}
                    >
                      <TouchableButton
                        type="button"
                        className={cn(
                          style.receiptReceiveModeButtons,
                          'px-4 mx-0 my-1 btn-ripple justify-content-center align-items-center border-0 fw-600  od-primary-btn-bg-color od-primary-btn-font-color'
                        )}
                        onClick={e => {
                          e.preventDefault();
                          handleCheck('print');
                        }}
                        style={{
                          background: serverAppTheme?.secondaryBtn,
                          lineHeight: '1.7025rem',
                          height: isLandScape && '56px',
                          fontSize: isLandScape && '1.5rem',
                        }}
                        rippleEffect={true}
                      >
                        {LABEL().PAY_PRINT_RECEIPT}
                      </TouchableButton>
                    </div>
                  )}
              </div>
              {/* 2.2 No Receipt */}
              <div className={cn("px-0 d-flex",isLandScape ? 'col-8 m-auto pt-0' : 'col-12 pt-3' )}>
                {(((isServerApp || isPaymentTerminal) &&
                  (receiptTypes?.print ||
                    receiptTypes?.sms ||
                    receiptTypes?.email)) ||
                  isTableTop) && (
                    <>
                      <div
                        className={cn(
                          isKiosk ? 'fs-30' : 'fs-18',
                          'col-8 pl-0 h-100 row mx-0 text-center justify-content-start align-items-center'
                        )}
                        style={{
                          textDecorationLine: 'underline',
                          // color: serverAppTheme?.NO_RECEIPT,
                          zIndex: '9999',
                        }}
                      >
                        <TouchableDiv
                          className="fs_24 fw-500"
                          onClick={handleNoReceipt}
                          tabIndex="0"
                          role="button"
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          {LABEL().RS_NO_RECEIPT}{' '}
                        </TouchableDiv>
                      </div>
                      <TouchableDiv
                        className="col-4 d-flex justify-content-end align-items-center text-center pr-0 h-50 fw-500 fs_24"
                        tabIndex="0"
                        role="button"
                        onClick={event => {
                          event.preventDefault();
                          setShowTicketDetails(true);
                        }}
                      >
                        <SearchIcon stroke={serverAppTheme?.iconcolor} />
                        <span className="pl-1 text-underline">
                          {LABEL().PC_DETAILS}
                        </span>
                      </TouchableDiv>
                    </>
                  )}
              </div>
            </>
          ) : (
            <>
              {/* 2.3 Need a Receipt*/}
              <div
                className={cn(
                  'row mx-0 text-center justify-content-center align-items-center',
                  isLandScape ? 'col-8 m-auto pb-0' : 'col-12 pb-3',
                  style.divForPayment
                )}
                style={{ fontSize: isLandScape ? '2.5rem' : '3rem' }}
              >
                {' '}
                {LABEL().RS_YOU_ARE_ALL_DONE}{' '}
              </div>
              <div className={cn("px-0 d-flex", isLandScape ? 'col-8 m-auto pt-2' : 'col-12 pt-3')}>
                <div
                  className={cn(
                    isKiosk ? 'fs-30' : 'fs-18',
                    'col-8 pl-0 h-100 row mx-0 text-center justify-content-start align-items-center'
                  )}
                  style={{
                    textDecorationLine: 'underline',
                    // color: serverAppTheme?.NO_RECEIPT,
                    zIndex: '9999',
                  }}
                >
                  <TouchableDiv
                    className="fs_24 fw-500"
                    tabIndex="0"
                    role="button"
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => {
                      handleReceiptType();
                    }}
                  >
                    {LABEL().RS_NEED_A_RECEIPT}{' '}
                  </TouchableDiv>
                </div>
                <TouchableDiv
                  className="col-4 d-flex justify-content-end align-items-center text-center pr-0 h-50 fw-500 fs_24"
                  tabIndex="0"
                  role="button"
                  onClick={event => {
                    event.preventDefault();
                    setShowTicketDetails(true);
                  }}
                >
                  <SearchIcon stroke={serverAppTheme?.iconcolor} />
                  <span className="pl-1 text-underline">
                    {LABEL().PC_DETAILS}
                  </span>
                </TouchableDiv>
              </div>
            </>
          )}
        </div>
        {/* 3 */}
        {seat?.paymentCheck?.splitType == 0 ? (
          <>
            {seat?.paymentCheck?.unpaidAmount > 0 ? (
              <>
                {/* 3.1.1 Partial Payment Receipt Screen */}
                <div
                  className={cn("col-12 px-0 text-center", isLandScape && 'd-flex')}
                  style={{ paddingTop: isLandScape ? '4.31rem' : '7.31rem', fontSize: isLandScape ? '3.375rem' : '' }}
                >
                  <div className={cn(isLandScape ? 'col-6 d-flex justify-content-end pr-2 fw-600' : `col-12 fw-500 ${style.fs40Fixed}`)}>DUE</div>
                  <div className={cn(isLandScape ? 'col-6 d-flex justify-content-start pl-2 fw-600' : `col-12 fw-300 ${style.fs96Fixed}`)}>
                    {LABEL().CURRENCY_SYMBOL +
                      seat?.paymentCheck?.checkUnpaidAmount?.toFixed(2)}
                  </div>
                </div>
              </>
            ) : (
              // 3.1.2 Full Payment Receipt Screen
              <div
                className={cn('col-12 m-auto text-center', isLandScape ? 'position-absolute' : '')}
                style={{ padding:  isLandScape ? '0' : '64px 0 0 0', width: isLandScape ? '150px' : '220px', bottom: isLandScape ? '15%' : '', left: isLandScape ? '42%' : ''}}
              >
                <img src={SUCCESS} className={cn(isLandScape ? "w-70" : 'w-100')} alt="success" />
              </div>
            )}
          </>
        ) : (
          <>
            {/* 3.2 Partial Payment Receipt Screen with next Guest */}
            {seat?.paymentChecks != null && !checkForUnpaidAmt() ? (
              <div
                className={cn('col-12 m-auto text-center')}
                style={{ padding: isLandScape ? '34px 0 0 0' : '64px 0 0 0', width: isLandScape ? '150px' : '220px' }}
              >
                <img src={SUCCESS} className="w-100" alt="success" />
              </div>
            ) : (
              <div
                className={cn(
                  'mx-0 row align-items-end col-12 justify-content-center text-center', isLandScape ? 'h-32' : 'h-50'
                )}
              >
                <img
                  src={handOff}
                  alt="fullimage"
                  className={cn('img-responsive center', isLandScape ? 'w-20' : 'w-85')}
                />
              </div>
            )}
            {seat?.paymentChecks != null &&
              !getSplitsComplete() &&
              checkForUnpaidAmt() && (
                <div
                  className={cn(
                    'px-0 btn-ripple justify-content-center align-items-center border-0 fw-600', isLandScape ? 'col-6 m-auto' : 'col-12 position-absolute',
                    style.receiptReceiveModeButtons
                  )}
                  style={{
                    height: isLandScape ? "56px" : '4.25rem',
                    bottom: isLandScape ? '8px' : '0',
                  }}
                >
                  <TouchableButton
                    type="button"
                    className={cn(
                      'align-items-center border-0 btn-ripple col-12 fw-600 h-100 justify-content-center px-0 rounded od-primary-btn-bg-color od-primary-btn-font-color'
                    )}
                    style={{
                      background: serverAppTheme?.secondaryBtn,
                      color: serverAppTheme?.btn_font_color,
                      lineHeight: '1.7025rem',
                    }}
                    onClick={e => {
                      e.preventDefault();
                      setPaymentConfirmation(prevState => ({
                        ...prevState,
                        isPaymentComplete: false,
                      }));
                      handleLoyaltyInfo({
                        phoneNumber: null,
                        email: null,
                        type: null,
                      });
                      setsmsEmailPrintObject({
                        smsReceiptStatus: false,
                        emailReceiptStatus: false,
                        printReceiptStatus: false,
                        NoReceipt: false,
                      });
                      navigate(
                        `${APP_CONFIG.BASE_URL}/receipt/${seat.id
                        }?ticketSplitTypeId=${urlSearchParams(
                          'ticketSplitTypeId'
                        )}&splitValue=1&screenType=28&type=splitType`,
                        { replace: true }
                      );
                      setPaymentType(28);
                    }}
                  >
                    <div
                      className={cn(
                        'fs_28 fw-600 text-uppercase',
                        // style.receiptReceiveModeButtons
                      )}
                    >
                      Next Guest
                    </div>
                  </TouchableButton>
                </div>
              )}
          </>
        )}
      </div>
    );
  };

  const PaymentConfirmationSuccess = () => {
    return (
      <div className={cn('col-12 w-100', isPaymentTerminal ? 'h-80' : 'h-75')}>
        <div className="col-12 p-0 h-40 row mx-0 justify-content-center align-items-end">
          <div className="col-12 py-2 h-100 row mx-0 align-items-center">
            <img
              src={getConfirmationLogo()}
              alt=""
              className="img-fluid mx-auto d-block h-100"
              style={{
                minHeight: '200px',
                maxHeight: '350px',
              }}
            />
          </div>
        </div>
        <div
          className={cn(
            isPaymentTerminal
              ? 'h-20 mx-0 row align-items-end col-12 justify-content-center text-center'
              : 'h-35 mx-0 row align-items-end col-12 justify-content-center text-center'
          )}
        >
          <img
            src={check}
            alt="fullimage"
            className="img-responsive center w-40"
          />
        </div>
        <div className="col-12 p-0 h-20 row text-center mx-0 justify-content-center align-items-end py-2">
          {isDone && Number(unpaidAmount) === 0 && (
            <button
              type="button"
              className={cn(
                'col-12 px-0 fs-30 fw-600 border-0 rounded btn-ripple text-white'
              )}
              onClick={() => handleRouteCheck()}
              style={{
                height: '7.5vh',
                backgroundColor: serverAppTheme?.secondaryBtn,
              }}
            >
              <div className="fs_24 fw-600">{LABEL().DONE}</div>
            </button>
          )}
          <div
            className={cn(
              'mb-2 fs-28 fw-100 text-uppercase',
              style.divForPayment
            )}
            style={{ color: serverAppTheme.primary_text }}
          >
            {LABEL().PAYMENT_NOW_COMPLETE}
          </div>
        </div>
        <div
          className={cn(
            'col-12 row justify-content-center mx-0 align-items-end py-1 text-center fs-15 fw-700',
            style.divForPayment
          )}
          style={{ color: serverAppTheme.primary_text }}
        >
          {authResponse?.ticket?.ticketPaymentTypeName === 'CreditCard' &&
            `Paid With ${authResponse?.ticket?.cardType
            } ending with ${authResponse?.ticket?.cardLast4?.slice(-4)}`}
          {authResponse?.ticket?.ticketPaymentTypeName === 'GiftCard' &&
            `Paid With ${authResponse?.ticket?.cardType
            } ending with ${authResponse?.ticket?.cardLast4?.slice(-4)}`}
          {authResponse?.ticket?.ticketPaymentTypeName === 'Cash' &&
            `Paid With ${authResponse?.ticket?.ticketPaymentTypeName}`}
        </div>
        <div
          className={cn(
            'col-12 row m-0 align-items-end',
            isPaymentTerminal ? 'h-30' : 'h-35'
          )}
          style={{ color: serverAppTheme.primary_text }}
        >
          <div className="col-12 row m-0 align-items-center text-center">
            {Number(unpaidAmount) <= 0 ? (
              <>
                <div
                  className={cn(
                    'col-12 py-2 text-center fs-26 fw-700 od-text-primary'
                  )}
                >
                  {CUSTOM_MESSAGES().GREAT_SERVING_YOU}
                </div>
                <div
                  className={cn(
                    'col-12 py-4 text-center fs-26 fw-700 od-text-primary'
                  )}
                >
                  {CUSTOM_MESSAGES().COME_BACK_SOON}
                </div>
              </>
            ) : (
              <div
                className={cn(
                  'col-12 py-1 text-center fs-26 fw-700 od-text-primary text-primary text-uppercase',
                  style.divForPayment
                )}
              >
                {CUSTOM_MESSAGES().CONTINUE_PAY_REMAINING_BALANCE}
              </div>
            )}
            {/* <div className="col-12">
            <img
              src={tick}
              alt="fullimage"
              className="img-responsive center"
            />
            <div className="mb-2 fs-18 od-text-primary text-primary">
              {successMessage || `${LABEL().PAYMENT_NOW_COMPLETE}. Paid with ${authResponse && authResponse.ticket && authResponse.ticket.ticketPaymentTypeName.replace(/([A-Z])/g, ' $1').toUpperCase()}`}
            </div>
          </div> */}
            {Number(unpaidAmount) > 0 && (
              <button
                type="button"
                className={cn(
                  'col-12 px-0 fs-30 fw-600 border-0 rounded btn-ripple text-white'
                )}
                onClick={() => handleRouteCheck()}
                style={{
                  height: '7.5vh',
                  backgroundColor: serverAppTheme?.secondaryBtn,
                }}
              >
                <div className={cn('fs-30 fw-600', style.divForPayment)}>
                  {LABEL().CONTINUE}
                </div>
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  const PaymentCallCenterConfirmationSuccess = () => {
    return (
      <div className="col-12 h-100 w-100 px-0">
        <div className='d-flex px-0' style={{ color: serverAppTheme?.primary_text }}>
          <div className="fs_16 fw-600 col-6 p-0 mb-1">
            {LABEL().TABLE}{' '}
            {(seat?.stationName?.length > 8
              ? seat?.stationName.substring(0, 9) + '...'
              : seat?.stationName) ||
              (seat?.name?.length > 8
                ? seat?.name.substring(0, 9) + '...'
                : seat?.name) ||
              seat?.stationNumber}
          </div>
          <div className={cn('fs-20 fw-700 p-0 mb-1 d-flex justify-content-end', isTogo ? (isLandScape ? 'col-5 ml-4' : 'col-5') : 'col-6')}>
            {seat?.number}
          </div>
        </div>
                  <div style={{ color: serverAppTheme?.primary_text }}>
                    <>
                      <div className="row w-auto justify-content-center text-left fw-600" style={{ fontSize: '24px', color: serverAppTheme?.primary_text, paddingTop: "0.75rem" }}>
                        {authData?.brandName}
                      </div>
                      <div className="row w-auto justify-content-center text-left fw-400" style={{ fontSize: "16px", color: serverAppTheme?.primary_text }}>
                        {authData?.address1}
                      </div>
                      <div className="row w-auto justify-content-center text-left fw-400" style={{ fontSize: "16px", color: serverAppTheme?.primary_text }}>
                        {authData?.address2}
                      </div>
                      <div className="row w-auto justify-content-center text-left fw-400" style={{ fontSize: "16px", color: serverAppTheme?.primary_text }}>
                        {authData?.city}{" "}{authData?.state}{" "}{authData?.zipCode}
                      </div>
                      <div className="row w-auto justify-content-center text-left fw-400" style={{ fontSize: "16px", color: serverAppTheme?.primary_text }}>
                        {authData?.countryCode === "1" ? getFormatedPhoneNumber(authData?.phoneNumber) : authData?.phoneNumber}
                      </div>
                    </>
                  </div>
                  <div className='align-items-center' style={{ color: serverAppTheme?.primary_text }}>
                    <div
                      className="py-2 fw-400 fs_20 h-10 align-items-center justify-content-center text-center"
                      style={{
                        marginTop: '20px',
                      }}
                    >
                      <div className={cn('fs_20 pb-2')}>
                        Name:<span className='fw-500 pl-1'>{callCenterModeUserInfo?.name}</span>
                      </div>
                      <div className={cn('fs_20 pb-2')}>
                        Phone Number: <span className='fw-500 pl-1'>{callCenterModeUserInfo?.phoneNumber}</span>
                      </div>
                      <div className={cn('fs_20')}>
                        Pickup Time: <span className='fw-500 pl-1'>{callCenterModeUserInfo?.pickupTime}</span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={cn("col-12 pb-2 d-flex align-items-center justify-content-center", !isLandScape ? 'pt-0' : 'pt-4')} style={{ top: isLandScape ? '' : '15%'}}
                  >
                    <img className={(isLandScape ? "w-10" : "w-35")} src={SUCCESS} alt="success" />
                  </div>
                  <div
                    className={cn("col-12 text-center fw-500  h-10 pt-20", isLandScape ? 'fs_20' : 'fs_24')}
                    style={{ marginTop: '36x', bottom: !isLandScape ? '30px' : '', position: !isLandScape ? 'absolute' : '', color: serverAppTheme?.primary_text }}
                  >
          {isTogo ? CUSTOM_MESSAGES().TG_GREAT_SERVING_YOU : CUSTOM_MESSAGES().CC_GREAT_SERVING_YOU}
          <div>{isTogo ? CUSTOM_MESSAGES().TG_COME_BACK_TO_SEE_US_AGAIN_SOON : CUSTOM_MESSAGES().CC_COME_BACK_TO_SEE_US_AGAIN_SOON}</div>
                  </div>
                </div>
    );
  };

  const PaymentConfirmationError = () => {
    return (
      <div className="col-12 h-100 w-100 row mx-0 justify-content-center align-items-end py-2 od-text-primary">
        <div className="col-12 fs-26 p-0 text-center">
          {CUSTOM_MESSAGES().PAYMENT_PROCESSING_ERROR}
        </div>
        <div className="col-12 p-0">
          <button
            type="button"
            className="btn rounded od-btn-primary btn-ripple my-1 w-100"
            onClick={() => handleRouteCheck()}
          >
            <div className="fs_18">{LABEL().DONE}</div>
          </button>
        </div>
      </div>
    );
  };

  const PaymentCallCenterConfirmationError = () => {
    return (
      <div className="col-12 h-100 w-100 row mx-0 justify-content-center align-items-end py-2 od-text-primary">
        <div className="col-12 fs-26 p-0 text-center">
          Your order has been canceled
        </div>
        <img
          src={CancelIcon}
          alt=""
          className="img-fluid mx-auto d-block h-100"
          style={{
            minHeight: '90px',
            maxHeight: '90px',
            maxWidth: '177px',
          }}
        />
        <div className="col-12 p-0"></div>
      </div>
    );
  };

  const PaymentErrorRetry = () => {
    return (
      <div className="col-12 w-100 h-10 row mx-0 justify-content-center align-items-end px-0">
        <div className="col-12 fs-26 p-0 text-center"></div>
        <div
          className={cn(
            'col-12 d-flex align-items-end p-0',
            isCounter || isDriveThru
              ? 'flex-column justify-content-end '
              : 'flex-row justify-content-center'
          )}
        >
          {(isCounter || isDriveThru) && (
            <button
              type="button"
              className="btn rounded btn-ripple my-1 w-100"
              onClick={() => handleChangePaymentType()}
            >
              <div className="fs-18">{LABEL().CHANGE_PAYMENT_TYPE}</div>
            </button>
          )}
          <button
            type="button"
            className={cn('btn68 rounded text-white btn-ripple')}
            style={{
              backgroundColor: serverAppTheme?.secondaryBtn,
              width: isLandScape ? '240px' : '100%',
            }}
            onClick={() => handleRetry()}
          >
            <div
              className="fw-600"
              style={{
                fontSize: isServerApp ? 'Max(3vw, 3vh)' : '20px',
                bottom: 0,
              }}
            >
              {LABEL().RETRY_}
            </div>
          </button>
        </div>
      </div>
    );
  };

  const PaymentErrorRetryPreAuth = () => {
    return (
      <div className="col-12 h-100 w-100 row mx-0 justify-content-center align-items-end px-0">
        <div className="col-12 h-100 d-flex align-items-end p-0 flex-column justify-content-end">
          {(isCounter || isDriveThru) && (
            <button
              type="button"
              className="btn rounded od-btn-primary btn-ripple my-1 w-100 text-white"
              onClick={() => handleChangePaymentType()}
              style={{
                height: '7.5vh',
                backgroundColor: '#0060FF',
                fontSize: '3vh',
                fontWeight: '600',
              }}
            >
              {LABEL().CHANGE_PAYMENT_TYPE}
            </button>
          )}
          <button
            type="button"
            className="btn rounded od-btn-primary btn-ripple my-1 w-100 text-white"
            onClick={() => preAuthFunctionCall()}
            style={{
              height: '7.5vh',
              backgroundColor: '#0060FF',
              fontSize: '3vh',
              fontWeight: '600',
            }}
          >
            {LABEL().RETRY}
          </button>
        </div>
      </div>
    );
  };

  const PayAnAmount = () => {
    return (
      <div
        className={cn('col-12 h-100  w-100', isServerApp && 'fs_28')}
        style={{ paddingTop: '5rem', color: serverAppTheme?.primary_text }}
      >
        <div
          className="col-12  px-0 h-12 m-auto fw-600 text-center  d-flex align-items-center justify-content-center"
          style={{
            fontSize: isServerApp ? '' : '20px',
            fontFamily: 'Poppins',
            top: '8%',
          }}
        >
          {CUSTOM_MESSAGES().PAY_AN_AMOUNT}
        </div>
        <div className="h-85 col-12 px-0">
          <Formik
            enableReinitialize
            initialValues={{ payAnAmount: 0 }}
            onSubmit={handlePayAnAmount}
            validate={validatePayAnAmount}
          >
            {() => {
              return (
                <Form className="h-100 position-relative">
                  <div
                    style={{ bottom: '0' }}
                    className="col-12 px-0 h-80 position-absolute"
                  >
                    <div className="col-12 px-0 h-100 position-relative">
                      <div className="col-12 px-0 h-88">
                        <SimpleKeyBoard
                          containerClass="h-100"
                          isDotRequired
                          haveCurrency={`${LABEL().CURRENCY_SYMBOL}`}
                          name="payAnAmount"
                          type="withoutDone"
                          btnName={LABEL().CONTINUE}
                          // customClass={}
                          customClassInput={style.customInputStyle}
                          screenType="payAnAmount"
                          serverAppTheme={serverAppTheme}
                        />
                      </div>
                      <div
                        style={{ bottom: '0' }}
                        className="col-12 p-0 h-15 d-flex justify-content-center align-items-end position-absolute"
                      >
                        <button
                          type="submit"
                          className="btn color-white btn-ripple my-1 w-100"
                          style={{
                            height: '7.5vh',
                            backgroundColor: serverAppTheme?.secondaryBtn,
                          }}
                        // onClick={() => handlePayAnAmount()}
                        >
                          <div
                            className={cn(
                              style.divForPayment,
                              style.loyalty_btn,
                              'fs_32 fw-600'
                            )}
                          >
                            {LABEL().CONTINUE}
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    );
  };

  const handlePayAnAmountModal = () => {
    return (
      <Modal
        isOpen={paymentType === 10}
        customClass2={cn('h-98 p-3')}
        style={{
          backgroundColor: serverAppTheme?.popUp_bg,
          borderRadius: '16px',
          border: serverAppTheme?.popupBorder,
          boxShadow: serverAppTheme?.popUp_box_shadow,
          height: '100%',
          position: 'relative',
        }}
      >
        <div
          style={{ right: '8px', top: '8px', zIndex: '10000' }}
          className="position-absolute"
          tabIndex="0"
          role="button"
          onClick={() => handleBackButton().url()}
        >
          <CrossPopup
            fill={serverAppTheme?.iconcolor}
            role="presentation"
            aria-hidden="true"
          />
        </div>
        <PayAnAmount />
      </Modal>
    );
  };

  const viewDetailsModal = () => {
    return (
      <>
        {tableData?.items && tableData?.items?.length > 0 ? (
          <Modal
            isOpen={paymentType === 25}
            isModalCenter
            customClass="h-100 w-100"
            customClass2="h-100 mt-0 maxW-100"
            style={{ height: '100%', backgroundColor: '#292C2D' }}
          >
            <div className="h-100 w-100 text-white od-text-primary">
              <div
                style={{ position: 'relative' }}
                className="h-96 m-3 od-text-primary"
              >
                <div className="row mx-0 h-10 flex-column w-100 pt-6">
                  <div className="d-flex align-items-center pb-2">
                    <div
                      className={cn(
                        style.tableOrderNum,
                        'col-11 d-flex justify-content-center align-items-center'
                      )}
                    >
                      <span>
                        {LABEL().TABLE}{' '}
                        {seat?.stationName || seat?.name || seat?.stationNumber}
                      </span>
                    </div>
                    <div
                      className="col-1 d-flex justify-content-center align-items-end"
                      tabIndex="0"
                      role="button"
                      aria-label="Close"
                      onClick={() => {
                        setPaymentType(4);
                      }}
                    >
                      <img src={cross} alt="cross" />
                    </div>
                  </div>
                </div>
                <div className="mx-0 h-85 flex-column w-100 pt-2">
                  {[1, 25].includes(paymentType) && (
                    <div
                      // key={item.menuItemId}
                      className={cn(
                        'col-12 h-2 row mx-0 w-100 align-content-center fw-400'
                      )}
                      style={{ fontFamily: 'Poppins', fontSize: '14px' }}
                    >
                      <div className="col-1 p-0 text-left">
                        {' '}
                        <span> {LABEL().QTY}</span>
                      </div>
                      <div className="col-7 p-0 text-left">
                        <div className="mx-0">{LABEL().ITEMS_LIST}</div>
                      </div>
                      <div className="col-1 p-0 text-left">
                        {' '}
                        <span> Seats</span>
                      </div>
                      <div className={cn('col-3 p-0 text-right')}>
                        <span>{LABEL().AMOUNT}</span>
                      </div>
                    </div>
                  )}
                  <hr
                    style={{
                      borderTop: '1px solid #4C4C4C',
                      margin: '10px 10px 10px 10px',
                    }}
                  />
                  <div className="overflowY h-95">
                    {tableData.items && tableData.items.length > 0 ? (
                      <div
                        className={cn(
                          'col-12 px-0 pt-0 w-100 od-text-primary overflowY',
                          isTableTop ||
                            isKiosk ||
                            ShowLandscapeMode ||
                            isPaymentTerminal ||
                            [23].includes(paymentType)
                            ? 'h-70'
                            : [1, 25].includes(paymentType)
                              ? 'h-82'
                              : [17].includes(paymentType)
                                ? 'h-90'
                                : 'h-60',
                          { 'px-2 pt-4 pb-2': isTableTop && !noRoundedBorder }
                        )}
                        style={{ fontFamily: 'Poppins' }}
                      >
                        <div></div>
                        {tableData?.items?.map(item => {
                          return (
                            <>
                              <div
                                key={item.menuItemId}
                                className={cn(
                                  'col-12 row mx-0 mt-1 py-2 w-100 align-content-center fs-18 fw-500'
                                  // styles.spanForPayment
                                )}
                              >
                                <div className="col-1 p-0 text-left">
                                  {' '}
                                  <span> {item.quantity}</span>
                                </div>
                                <div className="col-7 p-0 text-left">
                                  <div className="mx-0">
                                    {[2, 17, 23].includes(paymentType) &&
                                      !['payType', 'null', 'credit'].includes(
                                        'payType'
                                      ) ? (
                                      <span
                                        className={cn(
                                          'p-0 fs-16',
                                          item.quantity > 1 ||
                                            tableData.splitValue > 1
                                            ? 'col-4'
                                            : ''
                                        )}
                                      >
                                        {`${item.quantity > 1 ||
                                            tableData.splitValue > 1
                                            ? `${item.quantity}${tableData.splitValue > 1
                                              ? `/${tableData.splitValue} `
                                              : ''
                                            }x `
                                            : ''
                                          }`}
                                        {`${item.splitValueString}${item.menuItemName}`}
                                      </span>
                                    ) : (
                                      <span
                                        className={cn(
                                          'p-0',
                                          item.quantity > 1 ||
                                            tableData.splitValue > 1
                                            ? ''
                                            : 'col-11'
                                        )}
                                      >
                                        {item.quantity > 1
                                          ? item.quantity + ' x '
                                          : ''}{' '}
                                        {item.menuItemName}
                                      </span>
                                    )}
                                  </div>
                                </div>
                                {/* <div className="col-1 p-0 text-left"> */}
                                {item?.seats ? (
                                  <div className="col-1 px-0 h-8 d-flex justify-content-center align-items-center">
                                    <div className="bg-white fs-14 fw-500 color-black w-80 h-100 rounded d-flex justify-content-center align-items-center">
                                      {item?.seats?.length > 1
                                        ? '1/' + item?.seats?.length
                                        : props?.seat?.seats?.filter(
                                          i =>
                                            i?.id === item?.seats[0]?.seatId
                                        )[0]?.number}
                                    </div>
                                  </div>
                                ) : (
                                  <div className="col-1 px-0 h-8 d-flex justify-content-center align-items-center">
                                    <div className="bg-white fs-14 fw-500 color-black w-80 h-100 rounded d-flex justify-content-center align-items-center">
                                      {item?.seatIds?.length > 1
                                        ? '1/' + item?.seatIds?.length
                                        : props?.check?.seats?.filter(
                                          i => i?.id === item?.seatIds[0]
                                        )[0]?.number}
                                    </div>
                                  </div>
                                )}
                                {/* </div> */}
                                <div className={cn('col-3 p-0 text-right')}>
                                  {currenySymbol}
                                  {item.price.toFixed(2)}
                                </div>
                                <div className="col-12 p-0">
                                  {item.modifiers &&
                                    renderModifier(item.modifiers)}
                                </div>
                              </div>
                              <hr
                                style={{
                                  borderTop: '1px solid #4C4C4C',
                                  margin: '10px 10px 10px 10px',
                                }}
                              />
                            </>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="h-55 d-flex col-12 px-3 py-1 border-bottom border-color-primary od-text-primary overflowY fs-600 justify-content-center align-items-center fs-26">
                        {CUSTOM_MESSAGES().NO_ITEM_FOUND}
                      </div>
                    )}
                  </div>

                  {/* subtotal box */}
                  <div
                    className={cn(
                      isLandScape
                        ? 'col-12 border-color-primary od-text-primary overflowY mx-0 px-0 p-2'
                        : 'col-12 border-color-primary od-text-primary overflowY mx-0 px-0 p-3 position-fixed',
                      style.divForViewDetailsPayment,
                      isPaymentTerminal ||
                      ShowLandscapeMode ||
                      ([23].includes(paymentType) && 'h-auto')
                    )}
                    style={{ fontFamily: 'Poppins' }}
                  >
                    {countryCode === '44' ? (
                      <div className="row m-0 fw-600 fs-14">
                        <div className="col-8 p-0 text-left">
                          {LABEL().PAYEMENT_TOTAL_DUE}
                        </div>
                        {Number(urlSearchParams('screenType')) === 5 ? (
                          <div className="col-4 p-0 text-right">
                            {currenySymbol}
                          </div>
                        ) : (
                          <div className="col-4 p-0 text-right">
                            {currenySymbol}
                            {(tableData.totalAmount ||
                              tableData.totalAmount === 0) &&
                              countryCode != 44
                              ? taxAmoutWithTotal.toFixed(2)
                              : Number(urlSearchParams('screenType')) !== 17
                                ? urlSearchParams('type') != 'payType'
                                  ? Number(urlSearchParams('screenType')) === 1
                                    ? (
                                      taxAmoutWithTotal + tableData.taxAmount
                                    ).toFixed(2)
                                    : taxAmoutWithTotal.toFixed(2)
                                  : (
                                    taxAmoutWithTotal + tableData.taxAmount
                                  ).toFixed(2)
                                : Number(urlSearchParams('screenType')) === 17
                                  ? taxAmoutWithTotal.toFixed(2)
                                  : (
                                    taxAmoutWithTotal + tableData.taxAmount
                                  ).toFixed(2)}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className={cn('row mx-0 fw-600 fs-18')}>
                        <div className={cn('col-6 p-0 text-left')}>
                          {LABEL().SUB_TOTAL}
                        </div>

                        <div
                          className={cn('col-6 p-0 text-right fs-16 fw-600')}
                        >
                          {currenySymbol}
                          {(tableData.subTotalAmount ||
                            tableData.subTotalAmount === 0) &&
                            tableData.subTotalAmount.toFixed(2)}
                        </div>
                      </div>
                    )}
                    <div className="row mx-0 ">
                      <div
                        className={cn(
                          'col-6 p-0 text-left',
                          style.divForViewDetailsPayment
                        )}
                      >
                        {LABEL().TAX}
                      </div>
                      <div
                        className={cn(
                          'col-6 p-0 text-right',
                          style.divForViewDetailsPayment
                        )}
                      >
                        {currenySymbol}
                        {(tableData.taxAmount || tableData.taxAmount === 0) &&
                          tableData.taxAmount.toFixed(2)}
                      </div>
                    </div>
                    {tableData?.discountAmount > 0 && (
                      <div className="row mx-0 fw-700 fs-18">
                        <div className="col-6 p-0 text-left">
                          {LABEL().DISCOUNT_AMOUNT}
                        </div>
                        <div
                          className={cn(
                            'col-6 p-0 text-right',
                            style.divForViewDetailsPayment
                          )}
                        >
                          -{currenySymbol}
                          {tableData?.discountAmount.toFixed(2)}
                        </div>
                      </div>
                    )}
                    {tableData?.serviceChargeAmount > 0 && (
                      <div className="row mx-0 fw-700 fs-18">
                        <div className="col-6 p-0 text-left">
                          {LABEL().SERVICE_CHARGE}
                        </div>
                        <div
                          className={cn(
                            'col-6 p-0 text-right',
                            style.divForViewDetailsPayment
                          )}
                        >
                          {currenySymbol}
                          {tableData?.serviceChargeAmount.toFixed(2)}
                        </div>
                      </div>
                    )}
                    {[1, 20, 17].includes(paymentType) &&
                      getObjectValue(() => tipAmount > 0, false) && (
                        <div className="row m-0 fw-700 fs-18">
                          <div
                            className={cn(
                              'col-6 p-0 text-left',
                              style.divForViewDetailsPayment
                            )}
                          >
                            {LABEL().TIP}
                          </div>
                          <div
                            className={cn(
                              'col-6 p-0 text-right',
                              style.divForViewDetailsPayment
                            )}
                          >
                            {currenySymbol}
                            {(tipAmount && Number(tipAmount)?.toFixed(2)) ||
                              tableData?.tipAmount?.toFixed(2)}
                          </div>
                        </div>
                      )}
                    {countryCode !== '44' &&
                      ![20, 17, 18].includes(paymentType) && (
                        <div className="row mx-0 align-items-center">
                          <div
                            className={cn('col-6 p-0 text-left fw-600 fs-14')}
                          >
                            {LABEL().PAYEMENT_TOTAL_DUE}
                          </div>
                          <div
                            className={cn('col-6 p-0 text-right fs-18 fw-600')}
                          >
                            {currenySymbol}
                            {(tableData.totalAmount ||
                              tableData.totalAmount === 0) &&
                              tableData.totalAmount.toFixed(2)}
                          </div>
                        </div>
                      )}
                    {getObjectValue(() => tableData.paidAmount > 0, false) &&
                      ![5].includes(paymentType) && (
                        <div className="row m-0 fw-700 fs-18">
                          <div
                            className={cn(
                              'col-6 p-0 text-left',
                              style.divForViewDetailsPayment
                            )}
                          >
                            {LABEL().TOTAL_PAID}
                          </div>
                          <div
                            className={cn(
                              'col-6 p-0 text-right',
                              style.divForViewDetailsPayment
                            )}
                          >
                            {currenySymbol}
                            {tableData.paidAmount.toFixed(2)}
                          </div>
                        </div>
                      )}
                    {getObjectValue(() => paidTips > 0, false) &&
                      [1, 2, 10, 9].includes(paymentType) && (
                        <div className="row m-0 fw-700 fs-18">
                          <div className="col-6 p-0 text-left">
                            {LABEL().PAID_TIPS}{' '}
                          </div>
                          <div className={cn('col-6 p-0 text-right')}>
                            {currenySymbol}
                            {Number(paidTips).toFixed(2)}
                          </div>
                        </div>
                      )}
                    {getObjectValue(() => unpaidTips > 0, false) &&
                      [1, 2, 10, 9].includes(paymentType) && (
                        <div className="row m-0 fw-700 fs-18">
                          <div className="col-6 p-0 text-left">
                            {LABEL().UNPAID_TIPS}{' '}
                          </div>
                          <div
                            className={cn(
                              'col-6 p-0 text-right',
                              style.divForViewDetailsPayment
                            )}
                          >
                            {currenySymbol}
                            {Number(unpaidTips).toFixed(2)}
                          </div>
                        </div>
                      )}
                    {[2, 5, 6, 11, 12].includes(paymentType) &&
                      props.paymentFlowType === 4 &&
                      getObjectValue(() => tipAmount > 0, false) && (
                        <div className="row m-0 fw-700 fs-18">
                          <div
                            className={cn(
                              'col-6 p-0 text-left',
                              style.divForViewDetailsPayment
                            )}
                          >
                            {LABEL().TIP}
                          </div>
                          <div className={cn('col-6 p-0 text-right')}>
                            {currenySymbol}
                            {(tipAmount && Number(tipAmount)?.toFixed(2)) ||
                              tableData?.tipAmount?.toFixed(2)}
                          </div>
                        </div>
                      )}
                    {[2, 3, 4, 5, 6, 11, 12].includes(paymentType) &&
                      props.paymentFlowType === 3 &&
                      getObjectValue(() => tipAmount > 0, false) && (
                        <div className="row m-0 fw-700 fs-18">
                          <div className="col-6 p-0 text-left">
                            {LABEL().TIP}{' '}
                          </div>
                          <div
                            className={cn(
                              'col-6 p-0 text-right',
                              style.divForViewDetailsPayment
                            )}
                          >
                            {currenySymbol}
                            {(tipAmount && Number(tipAmount)?.toFixed(2)) ||
                              tableData?.tipAmount.toFixed(2)}
                          </div>
                        </div>
                      )}
                    {[23].includes(paymentType) ? (
                      <div className="row m-0 fw-700 fs-18">
                        <div
                          className={cn(
                            'col-6 p-0 text-left',
                            style.divForViewDetailsPayment
                          )}
                        >
                          {LABEL().TIP}
                        </div>
                        <div
                          className={cn(
                            'col-6 p-0 text-right',
                            style.divForViewDetailsPayment
                          )}
                        >
                          {currenySymbol}
                          {(tipAmount && Number(tipAmount)?.toFixed(2)) ||
                            tableData?.tipAmount?.toFixed(2)}
                        </div>
                      </div>
                    ) : null}

                    {[5, 6, 11].includes(paymentType) && (
                      <div className="row m-0 fw-700 fs-18">
                        <div className="col-6 p-0 text-left">
                          {LABEL().PAYMENT}{' '}
                        </div>
                      </div>
                    )}
                  </div>
                  {/* subtotal box ends */}
                  <button
                    id="btnItemisd"
                    className={cn(
                      'col-12 w-94 text-center align-content-center btn70 btn-ripple rounded-top border-0 fw-600 fs-28 mb-3 h-8'
                    )}
                    style={{
                      background: serverAppTheme?.secondaryBtn,
                      color: serverAppTheme?.btn_font_color,
                      bottom: '0',
                      position: 'fixed',
                      fontFamily: 'Poppins',
                      fontWeight: 600,
                    }}
                  >
                    {LABEL().CLOSE}
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        ) : (
          ''
        )}
      </>
    );
  };

  const IngenicoPayment = () => {
    return (
      <div className="col-12 h-100 w-100 row mx-0 justify-content-center align-items-center py-2 od-text-primary text-center">
        <div>
          <div className="fs-30 fw-600">
            {tipsMessage.length > 0
              ? tipsMessage
              : CUSTOM_MESSAGES().PLEASE_CONTINUE_THE_PAYMENT}
          </div>
          {tipsMessage.length === 0 && (
            <>
              <div
                className="col-12 h-30 fs-30 fw-600 p-0 text-center"
                style={{
                  fontSize: isServerApp
                    ? paymentType === 15
                      ? 'fs-30'
                      : '2rem'
                    : '20px',
                }}
              >
                {CUSTOM_MESSAGES().PRESS_CONTINUE}
              </div>
              <div
                className={cn(
                  paymentType
                    ? 'position-absolute col-12'
                    : 'col-12 h-30 d-flex align-items-end p-0 flex-column justify-content-end'
                )}
                style={{
                  bottom: paymentType === 15 ? '0' : '',
                  left: paymentType === 15 ? '0' : '',
                }}
              >
                {(isCounter || isDriveThru) && (
                  <button
                    type="button"
                    className="btn rounded od-btn-primary btn-primary btn-ripple my-1 w-100"
                    onClick={() => handleChangePaymentType()}
                  >
                    <div style={{ fontSize: isServerApp ? '2rem' : '20px' }}>
                      {LABEL().CHANGE_PAYMENT_TYPE}
                    </div>
                  </button>
                )}
                <button
                  type="button"
                  className="btn rounded od-btn-primary text-white btn-ripple my-1 w-100"
                  style={{ backgroundColor: '#0060FF', height: '7.5vh' }}
                  onClick={() => handleCreditCard()}
                >
                  <div
                    className="fw-600"
                    style={{ fontSize: isServerApp ? 'Max(3vw, 3vh)' : '20px' }}
                  >
                    {LABEL().CONTINUE}
                  </div>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };
  const commonProps = {
  PaymentPageBtn,
  isPaymentTerminal,
  serverAppTheme,
  navigate,
  location,
  onClearSplit
};
  const HandlePaymentScreenType = () => {
    switch (paymentType) {
      case 1:
        return isOrderingPortrait ? (
  <StartScreenPortrait {...commonProps} />
) : (
  <StartScreen {...commonProps} />
);
      case 2:
        return Fullcheck();
      case 3:
        return (
          <Pay
            paymentCallBack={paymentCallBack}
            handleFailureRoute={handleFailureRoute}
            handleProcessCreditError={handleProcessCreditError}
            headerImg={headerImg}
            creditRetryBtn={creditRetryBtn}
          />
        );
      case 4: 
        return isLandScape ? (
          <TipsLandScape
            tableData={tableData}
            currenySymbol={currenySymbol}
            tipsList={tipsList}
            active={active}
            serverAppTheme={serverAppTheme}
            mewVal={mewVal}
            getTipAmount={getTipAmount}
            tipList={tipList}
            handleKeyboardValue={handleKeyboardValue}
            setTotalVisible={setTotalVisible}
            handleButtonClick={handleButtonClick}
            setotherAmount={setotherAmount}
            setTotalVisibleVal={setTotalVisibleVal}
            tipAmount={tipAmount}
            disableOtherTip={disableOtherTip}
            enableOtherAmount={enableOtherAmount}
            enableOtherPercent={enableOtherPercent}
            otherAmount={otherAmount}
            setActive={setActive}
            setTipAmount={setTipAmount}
            setValue={setValue}
            setTipvalue={setTipvalue}
            setInputs={setInputs}
            inputs={inputs}
            inputName={inputName}
            isCounter={isCounter}
            totalAmountForTip={totalAmountForTip}
            authInfo={authInfo}
            showNoTipModal={showNoTipModal}
            setShowNoTipModal={setShowNoTipModal}
            handleOtherAmountContinue={handleOtherAmountContinue}
            validateTipsForCredit={validateTipsForCredit}
            handleCheck={handleCheck}
            selectedPayment={selectedPayment}
            otherAmountName={otherAmountName}
            setBtnPrimary={setBtnPrimary}
            btnPrimary={btnPrimary}
            totalVisible={totalVisible}
            value={value}
            checkDecimal={checkDecimal}
            tipvalue={tipvalue}
            onClickBtn={onClickBtn}
            onChangePersentage={onChangePersentage}
            applyTipForPayment={applyTipForPayment}
            showCheckSeat={props?.showCheckSeat}
            hasAutoGratuity={hasAutoGratuity}
            setInputName={setInputName}
            isDriveThru={isDriveThru}
            isTipOnlyEnabled={isTipOnlyEnabled}
            validateTipForTipOnly={validateTipForTipOnly}
            paymentCheckData={paymentCheckData}
            getTipOnlyOtherAmount={getTipOnlyOtherAmount}
          />
        ) : (
          <TipScreen
                      tableData={tableData}
            currenySymbol={currenySymbol}
            tipsList={tipsList}
            active={active}
            serverAppTheme={serverAppTheme}
            mewVal={mewVal}
            getTipAmount={getTipAmount}
            tipList={tipList}
            handleKeyboardValue={handleKeyboardValue}
            setTotalVisible={setTotalVisible}
            handleButtonClick={handleButtonClick}
            setotherAmount={setotherAmount}
            setTotalVisibleVal={setTotalVisibleVal}
            tipAmount={tipAmount}
            disableOtherTip={disableOtherTip}
            enableOtherAmount={enableOtherAmount}
            enableOtherPercent={enableOtherPercent}
            otherAmount={otherAmount}
            setActive={setActive}
            setTipAmount={setTipAmount}
            setValue={setValue}
            setTipvalue={setTipvalue}
            setInputs={setInputs}
            inputs={inputs}
            inputName={inputName}
            isCounter={isCounter}
            totalAmountForTip={totalAmountForTip}
            authInfo={authInfo}
            showNoTipModal={showNoTipModal}
            setShowNoTipModal={setShowNoTipModal}
            handleOtherAmountContinue={handleOtherAmountContinue}
            validateTipsForCredit={validateTipsForCredit}
            handleCheck={handleCheck}
            selectedPayment={selectedPayment}
            otherAmountName={otherAmountName}
            setBtnPrimary={setBtnPrimary}
            btnPrimary={btnPrimary}
            totalVisible={totalVisible}
            value={value}
            checkDecimal={checkDecimal}
            tipvalue={tipvalue}
            onClickBtn={onClickBtn}
            onChangePersentage={onChangePersentage}
            applyTipForPayment={applyTipForPayment}
            showCheckSeat={props?.showCheckSeat}
            hasAutoGratuity={hasAutoGratuity}
            setInputName={setInputName}
            isDriveThru={isDriveThru}
            isTipOnlyEnabled={isTipOnlyEnabled}
            validateTipForTipOnly={validateTipForTipOnly}
            paymentCheckData={paymentCheckData}
            getTipOnlyOtherAmount={getTipOnlyOtherAmount}
          />
        );
      case 5:
        return PaymentRecipt();
      case 6:
        return PaymentConfirmationSuccess();
      case 7:
        return PaymentConfirmationError();
      case 8:
        return PaymentErrorRetry();
      case 9:
        return (
          <SplitEvenly
            serverAppTheme={serverAppTheme}
            handleBackButtonClick={handleBackButtonClick}
            paymentAmount={paymentAmount}
            handleStagePaymentSubmit={handleStagePaymentSubmit}
            tableData={tableData}
            currenySymbol={currenySymbol}
            setErrorPopUp={setErrorPopUp}
            isOrderingPortrait = {isOrderingPortrait}
          />
        );
      case 10:
        return handlePayAnAmountModal();
      case 11:
        return (
          <Survey
            handleSurveySubmit={handleSurveySubmit}
            showCheckSeat={props?.showCheckSeat}
          />
        );
      case 12:
        return (
          <GiftCard
            setGiftBalance={setGiftBalance}
            giftCardImages={giftCardImages}
            isSecurityCode={isSecurityCode}
            tableData={tableData}
            makeGiftCardBalanceZero={makeGiftCardBalanceZero}
            setPaymentType={setPaymentType}
            giftBalanceAmt={giftBalance.balanceAmount}
            paymentAmount={
              Number(totalAmount) -
              Number(paidAmount) +
              (!giftBalance?.suppressTip ? Number(tipAmount) : 0)
            }
            giftCardPayment={giftCardPayment}
            onSubmit={handleGiftCard}
            giftCardSupportsSwipe={giftCardSupportsSwipe}
            openCardPopUp={openCardPopUp}
            giftCardNumber={giftCardNumber}
            handleGiftCancel={handleGiftCancel}
            setNotification={setNotification}
            giftCardMethods={giftCardMethods}
            setTipAmount={setTipAmount}
            authInfo={authInfo}
            serverAppTheme={serverAppTheme}
            setPayModeType={setPayModeType}
            navigate={navigate}
            location={location}
            setErrorPopUp={setErrorPopUp}
            isSwipe={isSwipe}
            newGiftCards={props.newGiftCards}
            giftCardBalanceInfo={props.giftCardBalanceInfo}
            giftCardBalanceCheck={props.giftCardBalanceCheck}
            onDeleteGiftCard={props.onDeleteGiftCard}
            seat={seat}
            showCheckSeat={props?.showCheckSeat}
          />
        );
      case 13:
        return <Charity />;
      case 14:
        return <QrPayFromPhone handleCheck={handleCheck} />;
      case 15:
        return <IngenicoPayment />;
      case 16:
        return (
          <CashReturn
            receiptTypes={receiptTypes}
            tableData={tableData}
            handleHideCancelIcon={handleHideCancelIcon}
            deviceInfo={deviceInfo}
            isCounter={isCounter}
            totalAmount={totalAmount}
            paymentType={paymentType}
            handleCheck={handleCheck}
            userInfo={userInfo}
            handleChangePaymentType={handleChangePaymentType}
            serverAppTheme={serverAppTheme}
            creditCardAmount={creditCardAmount}
            cashMode={cashMode}
            totalPaymentAmount={totalPaymentAmount}
            setCreditCardAmount={setCreditCardAmount}
            handleRouteCross={handleRouteCross}
            showCheckSeat={props?.showCheckSeat}
            setErrorPopUp={setErrorPopUp}
            isDriveThru={isDriveThru}
            isTipOnlyEnabled={isTipOnlyEnabled}
            seat={seat}
          />
        );
      case 17:
        return (
          <CashReturn
            receiptTypes={receiptTypes}
            tableData={tableData}
            handleHideCancelIcon={handleHideCancelIcon}
            deviceInfo={deviceInfo}
            isCounter={isCounter}
            totalAmount={totalAmount}
            paymentType={paymentType}
            handleCheck={handleCheck}
            userInfo={userInfo}
            serverAppTheme={serverAppTheme}
            setViewDetailsOpen={setViewDetailsOpen}
            viewDetailsOpen={viewDetailsOpen}
            navigate={navigate}
            location={location}
            showCheckSeat={props?.showCheckSeat}
            setErrorPopUp={setErrorPopUp}
            isDriveThru={isDriveThru}
            isTipOnlyEnabled={isTipOnlyEnabled}
            seat={seat}
          />
        );
      case 18:
        return (
          <CashReturn
            receiptTypes={receiptTypes}
            handleHideCancelIcon={handleHideCancelIcon}
            deviceInfo={deviceInfo}
            isCounter={isCounter}
            totalAmount={totalAmount}
            paymentType={paymentType}
            handleReceiptPopUpOpen={handleReceiptPopUpOpen}
            userInfo={userInfo}
            handleCheck={handleCheck}
            history={history}
            serverAppTheme={serverAppTheme}
            showCheckSeat={props?.showCheckSeat}
            setErrorPopUp={setErrorPopUp}
            isDriveThru={isDriveThru}
            isTipOnlyEnabled={isTipOnlyEnabled}
            seat={seat}
          />
        );
      case 19:
        return <PaymentErrorRetryPreAuth />;
      case 20:
        return PaymentCallCenterConfirmationSuccess();
      case 21:
        return PaymentCallCenterConfirmationError();
      case 22:
        return confirmationAndReceiptScreen();
      case 24:
        return OtherAmount();
      case 25:
        return viewDetailsModal();
      case 27:
        return giftCardReceipt();
      case 28:
        return (
          <CheckPresenter
            currenySymbol={currenySymbol}
            checkPresenterPay={checkPresenterPay}
            setPaymentFlowType={setPaymentFlowType}
            setPaymentType={setPaymentType}
            paymentType={paymentType}
            paymentCheck={seat?.paymentCheck}
            setIsCreditCardPayment={setIsCreditCardPayment}
            setCheckAndSeats={setCheckAndSeats}
            showCheckSeat={props?.showCheckSeat}
            serverAppTheme={serverAppTheme}
            navigate={navigate}
            location={location}
            resetTip={() => {
              setActive('resetTip');
              setotherAmount(false);
              setTipAmount(0);
              setValue('');
              setTipvalue('');
            }}
            disablePayment={disablePayment}
            deviceInfo={deviceInfo}
          />
        );
      case 29:
        return (
          <SplitBySeat
            seat={seat}
            serverAppTheme={serverAppTheme}
            seatItemHashTable={seatItemHashTable}
            tableData={splitTableData}
            setTableData={setSplitTableData}
            selectedStage={selectedStage}
            isOrderingPortrait = {isOrderingPortrait}
            selectedItem={selectedItem}
            selectedSeats={selectedSeats}
            setSelectedStage={setSelectedStage}
            handleCheckItems={handleCheckItems}
            handleBackButtonClick={handleBackButtonClick}
            handleOpenEditModal={handleOpenEditModal}
            handleOpenDeleteModal={handleOpenDeleteModal}
            handleStagePaymentSubmit={handleStagePaymentSubmit}
            deviceInfo={deviceInfo}
            handleStageSelection={handleStageSelection}
            handleCheckAllItems={handleCheckAllItems}
            handleStageMove={handleStageMove}
            navigate={navigate}
            location={location}
            setErrorPopUp={setErrorPopUp}
          />
        );
      case 30:
        return (
          <SplitBySelectedSeats
            history={history}
            setPaymentType={setPaymentType}
            handleOpenEditModal={handleOpenEditModal}
            handleOpenDeleteModal={handleOpenDeleteModal}
            seatItemHashTable={seatItemHashTable}
            tableData={splitTableData}
            setTableData={setSplitTableData}
            selectedStage={selectedStage}
            selectedItem={selectedItem}
            selectedSeats={selectedSeats}
            onClearSplit={onClearSplit}
            handleStageSelection={handleStageSelection}
            handleItemSelection={handleItemSelection}
            handleCheckItems={handleCheckItems}
            handleStageMove={handleStageMove}
            handleCardSelection={handleCardSelection}
            handleStagePaymentSubmit={handleStagePaymentSubmit}
            handleBackButtonClick={handleBackButtonClick}
            serverAppTheme={serverAppTheme}
            navigate={navigate}
            location={location}
            handleCheckAllItems={handleCheckAllItems}
          />
        );
      // case 31:
      //   return (
      //     <PaymentScreenOffer
      //       serverAppTheme={serverAppTheme}
      //       tableData={tableData}
      //       allMenuItems={allMenuItems}
      //       excludeItemFromReceiptScreen={excludeItemFromReceiptScreen}
      //       renderModifier={renderModifier}
      //       countryCode={countryCode}
      //       seat={seat}
      //       authInfo={authInfo}
      //       setViewDetailsOpen={setViewDetailsOpen}
      //       itemizedTipPercent={checkDecimal(
      //         ((100 * tipAmount) / getTipAmount(totalAmountForTip))?.toFixed(1)
      //       )}
      //       offerCouponGiftCard={offerCouponGiftCard}
      //       giftCardData={giftCardData}
      //       applyAnOfferScreen={applyAnOfferScreen}
      //       handleDeleteOffer={handleDeleteOffer}
      //       groupedLoyaltyOffers={groupedLoyaltyOffers}
      //       giftCardScreen={giftCardScreen}
      //       handleGiftCardDeleteBalance={handleGiftCardDeleteBalance}
      //       onOtherPaymentOptionClick={onOtherPaymentOptionClick}
      //       employeeCheckInRef={employeeCheckInRef}
      //       handleOtherPaymentOptions={handleOtherPaymentOptions}
      //       setIsCreditCardPayment={setIsCreditCardPayment}
      //       toggleOtherPaymentOption={toggleOtherPaymentOption}
      //       couponScreenRouting={couponScreenRouting}
      //       handleApplyOffer={handleApplyOffer}
      //       creditCardReadyScreen={creditCardReadyScreen}
      //       navigate={navigate}
      //       location={location}
      //       checkAndSeats={props?.checkAndSeats}
      //       showCheckSeat={props?.showCheckSeat}
      //       deviceInfo={deviceInfo}
      //       handleGiftCardPayment={handleGiftCardPayment}
      //       newGiftCards={seat?.paymentCheck?.giftCards || props.newGiftCards || []}
      //       onDeleteGiftCard={(card) => {
      //         giftCardDeleteBalance({
      //           deviceId: deviceInfo.deviceId,
      //           employeeId: Number(userInfo.id),
      //           employeeCard: userInfo?.employeeCard,
      //           checkHeaderId: tableData?.id,
      //           storeId: deviceInfo.storeId,
      //           giftCard: {
      //             accountNumber: card.accountNumber,
      //             paymentAmount: card.paymentAmount,
      //           },
      //           paymentCheck: seat?.paymentCheck,
      //           paymentChecks: seat?.paymentChecks,
      //         })
      //           .catch(err => {
      //             setErrorPopUp({
      //               res: err.message || err,
      //             });
      //           });
      //       }}
      //     />
      //   );
      case 31: {
        const baseProps = {
          serverAppTheme,
          tableData,
          allMenuItems,
          excludeItemFromReceiptScreen,
          renderModifier,
          countryCode,
          seat,
          authInfo,
          setViewDetailsOpen,
          itemizedTipPercent: checkDecimal(
            ((100 * tipAmount) / getTipAmount(totalAmountForTip))?.toFixed(1)
          ),
          offerCouponGiftCard,
          giftCardData,
          applyAnOfferScreen,
          handleDeleteOffer,
          groupedLoyaltyOffers,
          giftCardScreen,
          handleGiftCardDeleteBalance,
          onOtherPaymentOptionClick,
          employeeCheckInRef,
          handleOtherPaymentOptions,
          setIsCreditCardPayment,
          toggleOtherPaymentOption,
          couponScreenRouting,
          handleApplyOffer,
          creditCardReadyScreen,
          navigate,
          location,
          checkAndSeats: props?.checkAndSeats,
          showCheckSeat: props?.showCheckSeat,
          deviceInfo,
          handleGiftCardPayment,
          // preserve newGiftCards prop as in original
          newGiftCards: seat?.paymentCheck?.giftCards || props.newGiftCards || [],
          isLandScape,
          // pass the same delete handler as in original
          onDeleteGiftCard: (card) => {
            giftCardDeleteBalance({
              deviceId: deviceInfo.deviceId,
              employeeId: Number(userInfo.id),
              employeeCard: userInfo?.employeeCard,
              checkHeaderId: tableData?.id,
              storeId: deviceInfo.storeId,
              giftCard: {
                accountNumber: card.accountNumber,
                paymentAmount: card.paymentAmount,
              },
              paymentCheck: seat?.paymentCheck,
              paymentChecks: seat?.paymentChecks,
            }).catch(err => {
              setErrorPopUp({
                res: err.message || err,
              });
            });
          },
        };

        const Component = isLandScape ? PaymentScreenlandscape : PaymentScreenOffer;

        return <Component {...baseProps} />;
      }
      // case 32:
      //   return (
      //     <EmployeeInitiatedPaymentScreen
      //       currenySymbol={currenySymbol}
      //       serverAppTheme={serverAppTheme}
      //       history={history}
      //       setPaymentType={setPaymentType}
      //       // paymentCheckData={paymentCheckData}
      //       seat={seat}
      //       setSeat={props.setSeat}
      //       // setNotification={setNotification}
      //       PayByCardBtn={PayByCardBtn}
      //       previousScreen={previousScreen}
      //       handleGiftCardDeleteBalance={handleGiftCardDeleteBalance}
      //       handleCreditCardDeleteBalance={handleCreditCardDeleteBalance}
      //       setPayModeType={setPayModeType}
      //       payModeType={payModeType}
      //       handleCashClearBalance={handleCashClearBalance}
      //       // setInfoDeletion={setInfoDeletion}
      //       infoDeletion={infoDeletion}
      //       handleGiftCardPayment={handleGiftCardPayment}
      //       handleCashCompletePayment={handleCashCompletePayment}
      //       handlePayAtCounterPayment={handlePayAtCounterPayment}
      //       authInfo={authInfo}
      //       isPaymentTerminal={isPaymentTerminal}
      //       toggleOtherPaymentOption={toggleOtherPaymentOption}
      //       creditCardAmount={creditCardAmount}
      //       setCreditCardAmount={setCreditCardAmount}
      //       isAmountEdit={isAmountEdit}
      //       setIsAmountEdit={setIsAmountEdit}
      //       giftCardScreen={giftCardScreen}
      //       deviceInfo={deviceInfo}
      //       setErrorPopUp={setErrorPopUp}
      //       navigate={navigate}
      //       location={location}
      //       checkAndSeats={props.checkAndSeats}
      //       showCheckSeat={props?.showCheckSeat}
      //       tipInfo={authInfo?.tipInfo}
      //       hasAutoGratuity={hasAutoGratuity}
      //       isAutoGratuityPresent={isAutoGratuityPresent}
      //       isDriveThru={isDriveThru}
      //       setViewDetailsOpen={setViewDetailsOpen}
      //       giftCardDeleteBalance={giftCardDeleteBalance}
      //       userInfo={userInfo}
      //       tableData={tableData}
      //     />
      //   );
      case 32: {
        const baseProps = {
          currenySymbol,
          serverAppTheme,
          history,
          setPaymentType,
          // paymentCheckData,
          seat,
          setSeat: props.setSeat,
          // setNotification,
          PayByCardBtn,
          previousScreen,
          handleGiftCardDeleteBalance,
          handleCreditCardDeleteBalance,
          setPayModeType,
          payModeType,
          handleCashClearBalance,
          // setInfoDeletion,
          infoDeletion,
          handleGiftCardPayment,
          handleCashCompletePayment,
          handlePayAtCounterPayment,
          authInfo,
          isPaymentTerminal,
          toggleOtherPaymentOption,
          creditCardAmount,
          setCreditCardAmount,
          isAmountEdit,
          setIsAmountEdit,
          giftCardScreen,
          deviceInfo,
          setErrorPopUp,
          navigate,
          location,
          checkAndSeats: props.checkAndSeats,
          showCheckSeat: props?.showCheckSeat,
          tipInfo: authInfo?.tipInfo,
          hasAutoGratuity,
          isAutoGratuityPresent,
          isDriveThru,
          isCallCenter,
          setViewDetailsOpen,
          giftCardDeleteBalance,
          userInfo,
          tableData,
          isLandScape,
          getLoyaltyOfferState,
          speedOrderMode,
          isTogo,
          setSendOrderConfirmation,
          isCounter,
          isTipOnlyEnabled,
          handleBackForTipOnly,
          getRoundingPayment
        };

        const Component = isLandScape
          ? EmployeeInitiatedPaymentLandscapeScreen
          : EmployeeInitiatedPaymentScreen;

        return <Component {...baseProps} />;
      }
      case 36:
        return (
          <CouponScreen
            authInfo={authInfo}
            handleApplyOffer={handleApplyOffer}
            handleCouponCancel={handleCouponCancel}
            serverAppTheme={serverAppTheme}
            setErrorPopUp={setErrorPopUp}
            isLandScape={isLandScape}
            showCheckSeat={props?.showCheckSeat}
          />
        );
      case 33:
        return (
          <PaymentConfirmation
            seat={seat}
            paymentProcess={paymentProcess}
            paymentConfirmation={paymentConfirmation}
            history={history}
            serverAppTheme={serverAppTheme}
            setShowTicketDetails={setShowTicketDetails}
            isLandScape={isLandScape}
            showCheckSeat={props?.showCheckSeat}
          />
        );
      default:
        return <div />;
    }
  };

  return <>{HandlePaymentScreenType()}</>;
};

const mapStateToProps = ({payment}) => ({
  paymentLandscapeOrientation: payment.paymentLandscapeOrientation
})

export default connect(mapStateToProps)(PaymentScreenReVamp);
